(function (root, factory) {
  const catalog = factory();
  if (typeof module === 'object' && module.exports) module.exports = catalog;
  root.NoDrillCatalogData = catalog;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  const catalog = {
  "schemaVersion": 3,
  "roller": {
    "families": [
      {
        "id": "NDR-V2-RL-BO-001",
        "label": "Ocean Drive Blackout",
        "fabricTypes": [
          "blackout"
        ],
        "representativeMediaKey": "fabric-rl-bo-001-c01",
        "roomMediaKey": "room-rl-bo-001",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 5,
        "visualVariantCount": 5,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "patterned-tailored",
          "groupLabel": "Patterned & Tailored",
          "groupOrder": 3,
          "navigationState": "available"
        }
      },
      {
        "id": "NDR-V2-RL-BO-002",
        "label": "Las Olas Mosaic Blackout",
        "fabricTypes": [
          "blackout"
        ],
        "representativeMediaKey": "fabric-rl-bo-002-c01",
        "roomMediaKey": "room-rl-bo-002",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 5,
        "visualVariantCount": 5,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "patterned-tailored",
          "groupLabel": "Patterned & Tailored",
          "groupOrder": 3,
          "navigationState": "available"
        }
      },
      {
        "id": "NDR-V2-RL-BO-003",
        "label": "Harbor Linen Blackout",
        "fabricTypes": [
          "blackout"
        ],
        "representativeMediaKey": "fabric-rl-bo-003-c01",
        "roomMediaKey": "room-rl-bo-003",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 6,
        "visualVariantCount": 6,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "natural-woven",
          "groupLabel": "Natural & Woven",
          "groupOrder": 2,
          "navigationState": "available"
        }
      },
      {
        "id": "NDR-V2-RL-BO-004",
        "label": "Intracoastal Basketweave Blackout",
        "fabricTypes": [
          "blackout"
        ],
        "representativeMediaKey": "fabric-rl-bo-004-c01",
        "roomMediaKey": "room-rl-bo-004",
        "buildEligible": true,
        "configurationEligible": false,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 7,
        "visualVariantCount": 7,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "natural-woven",
          "groupLabel": "Natural & Woven",
          "groupOrder": 2,
          "navigationState": "held"
        }
      },
      {
        "id": "NDR-V2-RL-BO-005",
        "label": "Delray Textured Blackout",
        "fabricTypes": [
          "blackout"
        ],
        "representativeMediaKey": "fabric-rl-bo-005-c01",
        "roomMediaKey": "room-rl-bo-005",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 7,
        "visualVariantCount": 7,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "natural-woven",
          "groupLabel": "Natural & Woven",
          "groupOrder": 2,
          "navigationState": "available"
        }
      },
      {
        "id": "NDR-V2-RL-BO-006",
        "label": "Palm Cove Fineweave Blackout",
        "fabricTypes": [
          "blackout"
        ],
        "representativeMediaKey": "fabric-rl-bo-006-c01",
        "roomMediaKey": "room-rl-bo-006",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 7,
        "visualVariantCount": 7,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "clean-minimal",
          "groupLabel": "Clean & Minimal",
          "groupOrder": 1,
          "navigationState": "available"
        }
      },
      {
        "id": "NDR-V2-RL-BO-007",
        "label": "Biscayne Woven Blackout",
        "fabricTypes": [
          "blackout"
        ],
        "representativeMediaKey": "fabric-rl-bo-007-c01",
        "roomMediaKey": "room-rl-bo-007",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 7,
        "visualVariantCount": 7,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "natural-woven",
          "groupLabel": "Natural & Woven",
          "groupOrder": 2,
          "navigationState": "available"
        }
      },
      {
        "id": "NDR-V2-RL-BO-008",
        "label": "Lauderdale Textured Blackout",
        "fabricTypes": [
          "blackout"
        ],
        "representativeMediaKey": "fabric-rl-bo-008-c01",
        "roomMediaKey": "room-rl-bo-008",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 6,
        "visualVariantCount": 6,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "patterned-tailored",
          "groupLabel": "Patterned & Tailored",
          "groupOrder": 3,
          "navigationState": "available"
        }
      },
      {
        "id": "NDR-V2-RL-BO-009",
        "label": "Pompano Heathered Blackout",
        "fabricTypes": [
          "blackout"
        ],
        "representativeMediaKey": "fabric-rl-bo-009-c01",
        "roomMediaKey": "room-rl-bo-009",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 7,
        "visualVariantCount": 7,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "natural-woven",
          "groupLabel": "Natural & Woven",
          "groupOrder": 2,
          "navigationState": "available"
        }
      },
      {
        "id": "NDR-V2-RL-BO-010",
        "label": "Atlantic Smooth Blackout",
        "fabricTypes": [
          "blackout"
        ],
        "representativeMediaKey": "fabric-rl-bo-010-c01",
        "roomMediaKey": "room-rl-bo-010",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 7,
        "visualVariantCount": 7,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "clean-minimal",
          "groupLabel": "Clean & Minimal",
          "groupOrder": 1,
          "navigationState": "available"
        }
      },
      {
        "id": "NDR-V2-RL-BO-011",
        "label": "Key Biscayne Performance Blackout",
        "fabricTypes": [
          "blackout"
        ],
        "representativeMediaKey": "fabric-rl-bo-011-c01",
        "roomMediaKey": "room-rl-bo-011",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 4,
        "visualVariantCount": 4,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "clean-minimal",
          "groupLabel": "Clean & Minimal",
          "groupOrder": 1,
          "navigationState": "available"
        }
      },
      {
        "id": "NDR-V2-RL-BO-012",
        "label": "Coral Ridge Linear Blackout",
        "fabricTypes": [
          "blackout"
        ],
        "representativeMediaKey": "fabric-rl-bo-012-c01",
        "roomMediaKey": "room-rl-bo-012",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 4,
        "visualVariantCount": 4,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "patterned-tailored",
          "groupLabel": "Patterned & Tailored",
          "groupOrder": 3,
          "navigationState": "available"
        }
      },
      {
        "id": "NDR-V2-RL-BO-013",
        "label": "Victoria Park Microtexture Blackout",
        "fabricTypes": [
          "blackout"
        ],
        "representativeMediaKey": "fabric-rl-bo-013-c01",
        "roomMediaKey": "room-rl-bo-013",
        "buildEligible": true,
        "configurationEligible": false,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 6,
        "visualVariantCount": 6,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "clean-minimal",
          "groupLabel": "Clean & Minimal",
          "groupOrder": 1,
          "navigationState": "held"
        }
      },
      {
        "id": "NDR-V2-RL-BO-014",
        "label": "Ocean Park Matte Blackout",
        "fabricTypes": [
          "blackout"
        ],
        "representativeMediaKey": "fabric-rl-bo-014-c01",
        "roomMediaKey": "room-rl-bo-014",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 5,
        "visualVariantCount": 5,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "clean-minimal",
          "groupLabel": "Clean & Minimal",
          "groupOrder": 1,
          "navigationState": "available"
        }
      },
      {
        "id": "NDR-V2-RL-BO-015",
        "label": "Flagler Matte Blackout",
        "fabricTypes": [
          "blackout"
        ],
        "representativeMediaKey": "fabric-rl-bo-015-c01",
        "roomMediaKey": "room-rl-bo-015",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 4,
        "visualVariantCount": 4,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "clean-minimal",
          "groupLabel": "Clean & Minimal",
          "groupOrder": 1,
          "navigationState": "available"
        }
      },
      {
        "id": "NDR-V2-RL-BO-016",
        "label": "Intracoastal Linen Blackout",
        "fabricTypes": [
          "blackout"
        ],
        "representativeMediaKey": "fabric-rl-bo-016-c01",
        "roomMediaKey": "room-rl-bo-016",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 2,
        "visualVariantCount": 2,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "natural-woven",
          "groupLabel": "Natural & Woven",
          "groupOrder": 2,
          "navigationState": "available"
        }
      },
      {
        "id": "NDR-V2-RL-LF-001",
        "label": "Ocean Drive Light Filtering",
        "fabricTypes": [
          "light-filtering"
        ],
        "representativeMediaKey": "fabric-rl-lf-001-c01",
        "roomMediaKey": "room-rl-lf-001",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 5,
        "visualVariantCount": 5,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "natural-textured",
          "groupLabel": "Natural & Textured",
          "groupOrder": 2,
          "navigationState": "available"
        }
      },
      {
        "id": "NDR-V2-RL-LF-002",
        "label": "Las Olas Mosaic Light Filtering",
        "fabricTypes": [
          "light-filtering"
        ],
        "representativeMediaKey": "fabric-rl-lf-002-c01",
        "roomMediaKey": "room-rl-lf-002",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 5,
        "visualVariantCount": 5,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "patterned-tailored",
          "groupLabel": "Patterned & Tailored",
          "groupOrder": 3,
          "navigationState": "available"
        }
      },
      {
        "id": "NDR-V2-RL-LF-003",
        "label": "Harbor Linen Light Filtering",
        "fabricTypes": [
          "light-filtering"
        ],
        "representativeMediaKey": "fabric-rl-lf-003-c01",
        "roomMediaKey": "room-rl-lf-003",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 6,
        "visualVariantCount": 6,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "natural-textured",
          "groupLabel": "Natural & Textured",
          "groupOrder": 2,
          "navigationState": "available"
        }
      },
      {
        "id": "NDR-V2-RL-LF-004",
        "label": "Intracoastal Light Filtering",
        "fabricTypes": [
          "light-filtering"
        ],
        "representativeMediaKey": "fabric-rl-lf-004-c01",
        "roomMediaKey": "room-rl-lf-004",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 7,
        "visualVariantCount": 7,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "clean-minimal",
          "groupLabel": "Clean & Minimal",
          "groupOrder": 1,
          "navigationState": "available"
        }
      },
      {
        "id": "NDR-V2-RL-LF-005",
        "label": "Palm Cove Heathered Light Filtering",
        "fabricTypes": [
          "light-filtering"
        ],
        "representativeMediaKey": "fabric-rl-lf-005-c01",
        "roomMediaKey": "room-rl-lf-005",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 7,
        "visualVariantCount": 7,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "natural-textured",
          "groupLabel": "Natural & Textured",
          "groupOrder": 2,
          "navigationState": "available"
        }
      },
      {
        "id": "NDR-V2-RL-LF-006",
        "label": "Victoria Park Light Filtering",
        "fabricTypes": [
          "light-filtering"
        ],
        "representativeMediaKey": "fabric-rl-lf-006-c01",
        "roomMediaKey": "room-rl-lf-006",
        "buildEligible": true,
        "configurationEligible": false,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 4,
        "visualVariantCount": 4,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "patterned-tailored",
          "groupLabel": "Patterned & Tailored",
          "groupOrder": 3,
          "navigationState": "held"
        }
      },
      {
        "id": "NDR-V2-RL-LF-007",
        "label": "Bluewater Light Filtering",
        "fabricTypes": [
          "light-filtering"
        ],
        "representativeMediaKey": "fabric-rl-lf-007-c01",
        "roomMediaKey": "room-rl-lf-007",
        "buildEligible": true,
        "configurationEligible": false,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 5,
        "visualVariantCount": 5,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "patterned-tailored",
          "groupLabel": "Patterned & Tailored",
          "groupOrder": 3,
          "navigationState": "held"
        }
      },
      {
        "id": "NDR-V2-RL-LF-008",
        "label": "Marina Light Filtering",
        "fabricTypes": [
          "light-filtering"
        ],
        "representativeMediaKey": "fabric-rl-lf-008-c01",
        "roomMediaKey": "room-rl-lf-008",
        "buildEligible": true,
        "configurationEligible": false,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 6,
        "visualVariantCount": 6,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "clean-minimal",
          "groupLabel": "Clean & Minimal",
          "groupOrder": 1,
          "navigationState": "held"
        }
      },
      {
        "id": "NDR-V2-RL-LF-009",
        "label": "Intracoastal Linen Light Filtering",
        "fabricTypes": [
          "light-filtering"
        ],
        "representativeMediaKey": "fabric-rl-lf-009-c01",
        "roomMediaKey": "room-rl-lf-009",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 2,
        "visualVariantCount": 2,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "natural-textured",
          "groupLabel": "Natural & Textured",
          "groupOrder": 2,
          "navigationState": "available"
        }
      },
      {
        "id": "NDR-V2-RL-SO-001",
        "label": "Biscayne Solar 1%",
        "fabricTypes": [
          "solar"
        ],
        "representativeMediaKey": "fabric-rl-so-001-c01",
        "roomMediaKey": "room-rl-so-001",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 4,
        "visualVariantCount": 4,
        "navigation": {
          "axisId": "openness",
          "axisLabel": "Shop by openness",
          "groupId": "openness-1",
          "groupLabel": "1% Openness",
          "groupOrder": 1,
          "navigationState": "available"
        },
        "opennessFactorPct": 1
      },
      {
        "id": "NDR-V2-RL-SO-105",
        "label": "Ocean Reef Fineweave Solar 1%",
        "fabricTypes": [
          "solar"
        ],
        "representativeMediaKey": "fabric-rl-so-105-c01",
        "roomMediaKey": "room-rl-so-105",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 6,
        "visualVariantCount": 6,
        "navigation": {
          "axisId": "openness",
          "axisLabel": "Shop by openness",
          "groupId": "openness-1",
          "groupLabel": "1% Openness",
          "groupOrder": 1,
          "navigationState": "available"
        },
        "opennessFactorPct": 1
      },
      {
        "id": "NDR-V2-RL-SO-003",
        "label": "Biscayne Solar 3%",
        "fabricTypes": [
          "solar"
        ],
        "representativeMediaKey": "fabric-rl-so-003-c01",
        "roomMediaKey": "room-rl-so-003",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 4,
        "visualVariantCount": 4,
        "navigation": {
          "axisId": "openness",
          "axisLabel": "Shop by openness",
          "groupId": "openness-3",
          "groupLabel": "3% Openness",
          "groupOrder": 2,
          "navigationState": "available"
        },
        "opennessFactorPct": 3
      },
      {
        "id": "NDR-V2-RL-SO-103",
        "label": "Las Olas Linear Solar 3%",
        "fabricTypes": [
          "solar"
        ],
        "representativeMediaKey": "fabric-rl-so-103-c01",
        "roomMediaKey": "room-rl-so-103",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 3,
        "visualVariantCount": 3,
        "navigation": {
          "axisId": "openness",
          "axisLabel": "Shop by openness",
          "groupId": "openness-3",
          "groupLabel": "3% Openness",
          "groupOrder": 2,
          "navigationState": "available"
        },
        "opennessFactorPct": 3
      },
      {
        "id": "NDR-V2-RL-SO-104",
        "label": "Hillsboro Basketweave Solar 3%",
        "fabricTypes": [
          "solar"
        ],
        "representativeMediaKey": "fabric-rl-so-104-c01",
        "roomMediaKey": "room-rl-so-104",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 8,
        "visualVariantCount": 8,
        "navigation": {
          "axisId": "openness",
          "axisLabel": "Shop by openness",
          "groupId": "openness-3",
          "groupLabel": "3% Openness",
          "groupOrder": 2,
          "navigationState": "available"
        },
        "opennessFactorPct": 3
      },
      {
        "id": "NDR-V2-RL-SO-108",
        "label": "Bluewater Fineweave Solar 3%",
        "fabricTypes": [
          "solar"
        ],
        "representativeMediaKey": "fabric-rl-so-108-c01",
        "roomMediaKey": "room-rl-so-108",
        "buildEligible": true,
        "configurationEligible": false,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 6,
        "visualVariantCount": 6,
        "navigation": {
          "axisId": "openness",
          "axisLabel": "Shop by openness",
          "groupId": "openness-3",
          "groupLabel": "3% Openness",
          "groupOrder": 2,
          "navigationState": "held"
        },
        "opennessFactorPct": 3
      },
      {
        "id": "NDR-V2-RL-SO-005",
        "label": "Biscayne Solar 5%",
        "fabricTypes": [
          "solar"
        ],
        "representativeMediaKey": "fabric-rl-so-005-c01",
        "roomMediaKey": "room-rl-so-005",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 5,
        "visualVariantCount": 5,
        "navigation": {
          "axisId": "openness",
          "axisLabel": "Shop by openness",
          "groupId": "openness-5",
          "groupLabel": "5% Openness",
          "groupOrder": 3,
          "navigationState": "available"
        },
        "opennessFactorPct": 5
      },
      {
        "id": "NDR-V2-RL-SO-101",
        "label": "Intracoastal Basketweave Solar 5%",
        "fabricTypes": [
          "solar"
        ],
        "representativeMediaKey": "fabric-rl-so-101-c01",
        "roomMediaKey": "room-rl-so-101",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 9,
        "visualVariantCount": 9,
        "navigation": {
          "axisId": "openness",
          "axisLabel": "Shop by openness",
          "groupId": "openness-5",
          "groupLabel": "5% Openness",
          "groupOrder": 3,
          "navigationState": "available"
        },
        "opennessFactorPct": 5
      },
      {
        "id": "NDR-V2-RL-SO-102",
        "label": "Harbor Grid Solar 5%",
        "fabricTypes": [
          "solar"
        ],
        "representativeMediaKey": "fabric-rl-so-102-c01",
        "roomMediaKey": "room-rl-so-102",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 9,
        "visualVariantCount": 9,
        "navigation": {
          "axisId": "openness",
          "axisLabel": "Shop by openness",
          "groupId": "openness-5",
          "groupLabel": "5% Openness",
          "groupOrder": 3,
          "navigationState": "available"
        },
        "opennessFactorPct": 5
      },
      {
        "id": "NDR-V2-RL-SO-106",
        "label": "Marina Linear Solar 5%",
        "fabricTypes": [
          "solar"
        ],
        "representativeMediaKey": "fabric-rl-so-106-c01",
        "roomMediaKey": "room-rl-so-106",
        "buildEligible": true,
        "configurationEligible": false,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 3,
        "visualVariantCount": 3,
        "navigation": {
          "axisId": "openness",
          "axisLabel": "Shop by openness",
          "groupId": "openness-5",
          "groupLabel": "5% Openness",
          "groupOrder": 3,
          "navigationState": "held"
        },
        "opennessFactorPct": 5
      },
      {
        "id": "NDR-V2-RL-SO-109",
        "label": "Atlantic Denseweave · 0% openness, room darkening",
        "fabricTypes": [
          "solar"
        ],
        "representativeMediaKey": "fabric-rl-so-109-c01",
        "roomMediaKey": "room-rl-so-109",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 3,
        "visualVariantCount": 3,
        "navigation": {
          "axisId": "openness",
          "axisLabel": "Shop by openness",
          "groupId": "openness-0",
          "groupLabel": "0% openness, room darkening",
          "groupOrder": 0,
          "navigationState": "available"
        },
        "opennessFactorPct": 0
      },
      {
        "id": "NDR-V2-RL-SO-107",
        "label": "Regatta Colorweave Solar 6%",
        "fabricTypes": [
          "solar"
        ],
        "representativeMediaKey": "fabric-rl-so-107-c01",
        "roomMediaKey": "room-rl-so-107",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 8,
        "visualVariantCount": 8,
        "navigation": {
          "axisId": "openness",
          "axisLabel": "Shop by openness",
          "groupId": "openness-6",
          "groupLabel": "6% Openness",
          "groupOrder": 4,
          "navigationState": "available"
        },
        "opennessFactorPct": 6
      }
    ],
    "variants": [
      {
        "id": "NDR-V2-RL-BO-001-C01",
        "familyId": "NDR-V2-RL-BO-001",
        "label": "Coastal White",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-001-c01",
        "weaveDetailMediaKey": "weave-rl-bo-001-c01"
      },
      {
        "id": "NDR-V2-RL-BO-001-C02",
        "familyId": "NDR-V2-RL-BO-001",
        "label": "Oyster",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-001-c02",
        "weaveDetailMediaKey": "weave-rl-bo-001-c02"
      },
      {
        "id": "NDR-V2-RL-BO-001-C03",
        "familyId": "NDR-V2-RL-BO-001",
        "label": "Sandbar",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-001-c03",
        "weaveDetailMediaKey": "weave-rl-bo-001-c03"
      },
      {
        "id": "NDR-V2-RL-BO-001-C04",
        "familyId": "NDR-V2-RL-BO-001",
        "label": "Graphite",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-001-c04",
        "weaveDetailMediaKey": "weave-rl-bo-001-c04"
      },
      {
        "id": "NDR-V2-RL-BO-001-C05",
        "familyId": "NDR-V2-RL-BO-001",
        "label": "Driftwood",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-001-c05",
        "weaveDetailMediaKey": "weave-rl-bo-001-c05"
      },
      {
        "id": "NDR-V2-RL-BO-002-C01",
        "familyId": "NDR-V2-RL-BO-002",
        "label": "Graphic White",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-002-c01",
        "weaveDetailMediaKey": "weave-rl-bo-002-c01"
      },
      {
        "id": "NDR-V2-RL-BO-002-C02",
        "familyId": "NDR-V2-RL-BO-002",
        "label": "Soft White",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-002-c02",
        "weaveDetailMediaKey": "weave-rl-bo-002-c02"
      },
      {
        "id": "NDR-V2-RL-BO-002-C03",
        "familyId": "NDR-V2-RL-BO-002",
        "label": "Silver Mosaic",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-002-c03",
        "weaveDetailMediaKey": "weave-rl-bo-002-c03"
      },
      {
        "id": "NDR-V2-RL-BO-002-C04",
        "familyId": "NDR-V2-RL-BO-002",
        "label": "Graphite Mosaic",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-002-c04",
        "weaveDetailMediaKey": "weave-rl-bo-002-c04"
      },
      {
        "id": "NDR-V2-RL-BO-002-C05",
        "familyId": "NDR-V2-RL-BO-002",
        "label": "Onyx Mosaic",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-002-c05",
        "weaveDetailMediaKey": "weave-rl-bo-002-c05"
      },
      {
        "id": "NDR-V2-RL-BO-003-C01",
        "familyId": "NDR-V2-RL-BO-003",
        "label": "Cloud White",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-003-c01",
        "weaveDetailMediaKey": "weave-rl-bo-003-c01"
      },
      {
        "id": "NDR-V2-RL-BO-003-C02",
        "familyId": "NDR-V2-RL-BO-003",
        "label": "Oyster",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-003-c02",
        "weaveDetailMediaKey": "weave-rl-bo-003-c02"
      },
      {
        "id": "NDR-V2-RL-BO-003-C03",
        "familyId": "NDR-V2-RL-BO-003",
        "label": "Linen",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-003-c03",
        "weaveDetailMediaKey": "weave-rl-bo-003-c03"
      },
      {
        "id": "NDR-V2-RL-BO-003-C04",
        "familyId": "NDR-V2-RL-BO-003",
        "label": "Silver",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-003-c04",
        "weaveDetailMediaKey": "weave-rl-bo-003-c04"
      },
      {
        "id": "NDR-V2-RL-BO-003-C05",
        "familyId": "NDR-V2-RL-BO-003",
        "label": "Graphite",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-003-c05",
        "weaveDetailMediaKey": "weave-rl-bo-003-c05"
      },
      {
        "id": "NDR-V2-RL-BO-003-C06",
        "familyId": "NDR-V2-RL-BO-003",
        "label": "Onyx",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-003-c06",
        "weaveDetailMediaKey": "weave-rl-bo-003-c06"
      },
      {
        "id": "NDR-V2-RL-BO-004-C01",
        "familyId": "NDR-V2-RL-BO-004",
        "label": "Cloud White",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-004-c01",
        "weaveDetailMediaKey": "weave-rl-bo-004-c01"
      },
      {
        "id": "NDR-V2-RL-BO-004-C02",
        "familyId": "NDR-V2-RL-BO-004",
        "label": "Oyster",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-004-c02",
        "weaveDetailMediaKey": "weave-rl-bo-004-c02"
      },
      {
        "id": "NDR-V2-RL-BO-004-C03",
        "familyId": "NDR-V2-RL-BO-004",
        "label": "Linen",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-004-c03",
        "weaveDetailMediaKey": "weave-rl-bo-004-c03"
      },
      {
        "id": "NDR-V2-RL-BO-004-C04",
        "familyId": "NDR-V2-RL-BO-004",
        "label": "Silver",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-004-c04",
        "weaveDetailMediaKey": "weave-rl-bo-004-c04"
      },
      {
        "id": "NDR-V2-RL-BO-004-C05",
        "familyId": "NDR-V2-RL-BO-004",
        "label": "Pewter",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-004-c05",
        "weaveDetailMediaKey": "weave-rl-bo-004-c05"
      },
      {
        "id": "NDR-V2-RL-BO-004-C06",
        "familyId": "NDR-V2-RL-BO-004",
        "label": "Graphite",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-004-c06",
        "weaveDetailMediaKey": "weave-rl-bo-004-c06"
      },
      {
        "id": "NDR-V2-RL-BO-004-C07",
        "familyId": "NDR-V2-RL-BO-004",
        "label": "Onyx",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-004-c07",
        "weaveDetailMediaKey": "weave-rl-bo-004-c07"
      },
      {
        "id": "NDR-V2-RL-BO-005-C01",
        "familyId": "NDR-V2-RL-BO-005",
        "label": "Cloud White",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-005-c01",
        "weaveDetailMediaKey": "weave-rl-bo-005-c01"
      },
      {
        "id": "NDR-V2-RL-BO-005-C02",
        "familyId": "NDR-V2-RL-BO-005",
        "label": "Oyster",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-005-c02",
        "weaveDetailMediaKey": "weave-rl-bo-005-c02"
      },
      {
        "id": "NDR-V2-RL-BO-005-C03",
        "familyId": "NDR-V2-RL-BO-005",
        "label": "Linen",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-005-c03",
        "weaveDetailMediaKey": "weave-rl-bo-005-c03"
      },
      {
        "id": "NDR-V2-RL-BO-005-C04",
        "familyId": "NDR-V2-RL-BO-005",
        "label": "Silver",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-005-c04",
        "weaveDetailMediaKey": "weave-rl-bo-005-c04"
      },
      {
        "id": "NDR-V2-RL-BO-005-C05",
        "familyId": "NDR-V2-RL-BO-005",
        "label": "Bronze",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-005-c05",
        "weaveDetailMediaKey": "weave-rl-bo-005-c05"
      },
      {
        "id": "NDR-V2-RL-BO-005-C06",
        "familyId": "NDR-V2-RL-BO-005",
        "label": "Espresso",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-005-c06",
        "weaveDetailMediaKey": "weave-rl-bo-005-c06"
      },
      {
        "id": "NDR-V2-RL-BO-005-C07",
        "familyId": "NDR-V2-RL-BO-005",
        "label": "Onyx",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-005-c07",
        "weaveDetailMediaKey": "weave-rl-bo-005-c07"
      },
      {
        "id": "NDR-V2-RL-BO-006-C01",
        "familyId": "NDR-V2-RL-BO-006",
        "label": "Cloud White",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-006-c01",
        "weaveDetailMediaKey": "weave-rl-bo-006-c01"
      },
      {
        "id": "NDR-V2-RL-BO-006-C02",
        "familyId": "NDR-V2-RL-BO-006",
        "label": "Oyster",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-006-c02",
        "weaveDetailMediaKey": "weave-rl-bo-006-c02"
      },
      {
        "id": "NDR-V2-RL-BO-006-C03",
        "familyId": "NDR-V2-RL-BO-006",
        "label": "Silver",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-006-c03",
        "weaveDetailMediaKey": "weave-rl-bo-006-c03"
      },
      {
        "id": "NDR-V2-RL-BO-006-C04",
        "familyId": "NDR-V2-RL-BO-006",
        "label": "Mist",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-006-c04",
        "weaveDetailMediaKey": "weave-rl-bo-006-c04"
      },
      {
        "id": "NDR-V2-RL-BO-006-C05",
        "familyId": "NDR-V2-RL-BO-006",
        "label": "Pewter",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-006-c05",
        "weaveDetailMediaKey": "weave-rl-bo-006-c05"
      },
      {
        "id": "NDR-V2-RL-BO-006-C06",
        "familyId": "NDR-V2-RL-BO-006",
        "label": "Graphite",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-006-c06",
        "weaveDetailMediaKey": "weave-rl-bo-006-c06"
      },
      {
        "id": "NDR-V2-RL-BO-006-C07",
        "familyId": "NDR-V2-RL-BO-006",
        "label": "Charcoal",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-006-c07",
        "weaveDetailMediaKey": "weave-rl-bo-006-c07"
      },
      {
        "id": "NDR-V2-RL-BO-007-C01",
        "familyId": "NDR-V2-RL-BO-007",
        "label": "Cloud White",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-007-c01",
        "weaveDetailMediaKey": "weave-rl-bo-007-c01"
      },
      {
        "id": "NDR-V2-RL-BO-007-C02",
        "familyId": "NDR-V2-RL-BO-007",
        "label": "Linen",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-007-c02",
        "weaveDetailMediaKey": "weave-rl-bo-007-c02"
      },
      {
        "id": "NDR-V2-RL-BO-007-C03",
        "familyId": "NDR-V2-RL-BO-007",
        "label": "Sage",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-007-c03",
        "weaveDetailMediaKey": "weave-rl-bo-007-c03"
      },
      {
        "id": "NDR-V2-RL-BO-007-C04",
        "familyId": "NDR-V2-RL-BO-007",
        "label": "Driftwood",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-007-c04",
        "weaveDetailMediaKey": "weave-rl-bo-007-c04"
      },
      {
        "id": "NDR-V2-RL-BO-007-C05",
        "familyId": "NDR-V2-RL-BO-007",
        "label": "Silver",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-007-c05",
        "weaveDetailMediaKey": "weave-rl-bo-007-c05"
      },
      {
        "id": "NDR-V2-RL-BO-007-C06",
        "familyId": "NDR-V2-RL-BO-007",
        "label": "Charcoal",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-007-c06",
        "weaveDetailMediaKey": "weave-rl-bo-007-c06"
      },
      {
        "id": "NDR-V2-RL-BO-007-C07",
        "familyId": "NDR-V2-RL-BO-007",
        "label": "Graphite",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-007-c07",
        "weaveDetailMediaKey": "weave-rl-bo-007-c07"
      },
      {
        "id": "NDR-V2-RL-BO-008-C01",
        "familyId": "NDR-V2-RL-BO-008",
        "label": "Cloud White",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-008-c01",
        "weaveDetailMediaKey": "weave-rl-bo-008-c01"
      },
      {
        "id": "NDR-V2-RL-BO-008-C02",
        "familyId": "NDR-V2-RL-BO-008",
        "label": "Linen",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-008-c02",
        "weaveDetailMediaKey": "weave-rl-bo-008-c02"
      },
      {
        "id": "NDR-V2-RL-BO-008-C03",
        "familyId": "NDR-V2-RL-BO-008",
        "label": "Sandbar",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-008-c03",
        "weaveDetailMediaKey": "weave-rl-bo-008-c03"
      },
      {
        "id": "NDR-V2-RL-BO-008-C04",
        "familyId": "NDR-V2-RL-BO-008",
        "label": "Silver Stripe",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-008-c04",
        "weaveDetailMediaKey": "weave-rl-bo-008-c04"
      },
      {
        "id": "NDR-V2-RL-BO-008-C05",
        "familyId": "NDR-V2-RL-BO-008",
        "label": "Graphite Stripe",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-008-c05",
        "weaveDetailMediaKey": "weave-rl-bo-008-c05"
      },
      {
        "id": "NDR-V2-RL-BO-008-C06",
        "familyId": "NDR-V2-RL-BO-008",
        "label": "Onyx",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-008-c06",
        "weaveDetailMediaKey": "weave-rl-bo-008-c06"
      },
      {
        "id": "NDR-V2-RL-BO-009-C01",
        "familyId": "NDR-V2-RL-BO-009",
        "label": "Cloud White",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-009-c01",
        "weaveDetailMediaKey": "weave-rl-bo-009-c01"
      },
      {
        "id": "NDR-V2-RL-BO-009-C02",
        "familyId": "NDR-V2-RL-BO-009",
        "label": "Oatmeal",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-009-c02",
        "weaveDetailMediaKey": "weave-rl-bo-009-c02"
      },
      {
        "id": "NDR-V2-RL-BO-009-C03",
        "familyId": "NDR-V2-RL-BO-009",
        "label": "Driftwood",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-009-c03",
        "weaveDetailMediaKey": "weave-rl-bo-009-c03"
      },
      {
        "id": "NDR-V2-RL-BO-009-C04",
        "familyId": "NDR-V2-RL-BO-009",
        "label": "Silver",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-009-c04",
        "weaveDetailMediaKey": "weave-rl-bo-009-c04"
      },
      {
        "id": "NDR-V2-RL-BO-009-C05",
        "familyId": "NDR-V2-RL-BO-009",
        "label": "Pewter",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-009-c05",
        "weaveDetailMediaKey": "weave-rl-bo-009-c05"
      },
      {
        "id": "NDR-V2-RL-BO-009-C06",
        "familyId": "NDR-V2-RL-BO-009",
        "label": "Graphite",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-009-c06",
        "weaveDetailMediaKey": "weave-rl-bo-009-c06"
      },
      {
        "id": "NDR-V2-RL-BO-009-C07",
        "familyId": "NDR-V2-RL-BO-009",
        "label": "Onyx",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-009-c07",
        "weaveDetailMediaKey": "weave-rl-bo-009-c07"
      },
      {
        "id": "NDR-V2-RL-BO-010-C01",
        "familyId": "NDR-V2-RL-BO-010",
        "label": "Cloud White",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-010-c01",
        "weaveDetailMediaKey": "weave-rl-bo-010-c01"
      },
      {
        "id": "NDR-V2-RL-BO-010-C02",
        "familyId": "NDR-V2-RL-BO-010",
        "label": "Linen",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-010-c02",
        "weaveDetailMediaKey": "weave-rl-bo-010-c02"
      },
      {
        "id": "NDR-V2-RL-BO-010-C03",
        "familyId": "NDR-V2-RL-BO-010",
        "label": "Silver",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-010-c03",
        "weaveDetailMediaKey": "weave-rl-bo-010-c03"
      },
      {
        "id": "NDR-V2-RL-BO-010-C04",
        "familyId": "NDR-V2-RL-BO-010",
        "label": "Soft Gold",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-010-c04",
        "weaveDetailMediaKey": "weave-rl-bo-010-c04"
      },
      {
        "id": "NDR-V2-RL-BO-010-C05",
        "familyId": "NDR-V2-RL-BO-010",
        "label": "Pewter",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-010-c05",
        "weaveDetailMediaKey": "weave-rl-bo-010-c05"
      },
      {
        "id": "NDR-V2-RL-BO-010-C06",
        "familyId": "NDR-V2-RL-BO-010",
        "label": "Olive",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-010-c06",
        "weaveDetailMediaKey": "weave-rl-bo-010-c06"
      },
      {
        "id": "NDR-V2-RL-BO-010-C07",
        "familyId": "NDR-V2-RL-BO-010",
        "label": "Onyx",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-010-c07",
        "weaveDetailMediaKey": "weave-rl-bo-010-c07"
      },
      {
        "id": "NDR-V2-RL-BO-011-C01",
        "familyId": "NDR-V2-RL-BO-011",
        "label": "Cloud White",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-011-c01",
        "weaveDetailMediaKey": "weave-rl-bo-011-c01"
      },
      {
        "id": "NDR-V2-RL-BO-011-C02",
        "familyId": "NDR-V2-RL-BO-011",
        "label": "Linen",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-011-c02",
        "weaveDetailMediaKey": "weave-rl-bo-011-c02"
      },
      {
        "id": "NDR-V2-RL-BO-011-C03",
        "familyId": "NDR-V2-RL-BO-011",
        "label": "Silver",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-011-c03",
        "weaveDetailMediaKey": "weave-rl-bo-011-c03"
      },
      {
        "id": "NDR-V2-RL-BO-011-C04",
        "familyId": "NDR-V2-RL-BO-011",
        "label": "Graphite",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-011-c04",
        "weaveDetailMediaKey": "weave-rl-bo-011-c04"
      },
      {
        "id": "NDR-V2-RL-BO-012-C01",
        "familyId": "NDR-V2-RL-BO-012",
        "label": "Cloud White",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-012-c01",
        "weaveDetailMediaKey": "weave-rl-bo-012-c01"
      },
      {
        "id": "NDR-V2-RL-BO-012-C02",
        "familyId": "NDR-V2-RL-BO-012",
        "label": "Linen",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-012-c02",
        "weaveDetailMediaKey": "weave-rl-bo-012-c02"
      },
      {
        "id": "NDR-V2-RL-BO-012-C03",
        "familyId": "NDR-V2-RL-BO-012",
        "label": "Oatmeal",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-012-c03",
        "weaveDetailMediaKey": "weave-rl-bo-012-c03"
      },
      {
        "id": "NDR-V2-RL-BO-012-C04",
        "familyId": "NDR-V2-RL-BO-012",
        "label": "Silver",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-012-c04",
        "weaveDetailMediaKey": "weave-rl-bo-012-c04"
      },
      {
        "id": "NDR-V2-RL-BO-013-C01",
        "familyId": "NDR-V2-RL-BO-013",
        "label": "Cloud White",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-013-c01",
        "weaveDetailMediaKey": "weave-rl-bo-013-c01"
      },
      {
        "id": "NDR-V2-RL-BO-013-C02",
        "familyId": "NDR-V2-RL-BO-013",
        "label": "Soft Gold",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-013-c02",
        "weaveDetailMediaKey": "weave-rl-bo-013-c02"
      },
      {
        "id": "NDR-V2-RL-BO-013-C03",
        "familyId": "NDR-V2-RL-BO-013",
        "label": "Sage",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-013-c03",
        "weaveDetailMediaKey": "weave-rl-bo-013-c03"
      },
      {
        "id": "NDR-V2-RL-BO-013-C04",
        "familyId": "NDR-V2-RL-BO-013",
        "label": "Sky",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-013-c04",
        "weaveDetailMediaKey": "weave-rl-bo-013-c04"
      },
      {
        "id": "NDR-V2-RL-BO-013-C05",
        "familyId": "NDR-V2-RL-BO-013",
        "label": "Silver",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-013-c05",
        "weaveDetailMediaKey": "weave-rl-bo-013-c05"
      },
      {
        "id": "NDR-V2-RL-BO-013-C06",
        "familyId": "NDR-V2-RL-BO-013",
        "label": "Graphite",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-013-c06",
        "weaveDetailMediaKey": "weave-rl-bo-013-c06"
      },
      {
        "id": "NDR-V2-RL-BO-014-C01",
        "familyId": "NDR-V2-RL-BO-014",
        "label": "Cloud White",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-014-c01",
        "weaveDetailMediaKey": "weave-rl-bo-014-c01"
      },
      {
        "id": "NDR-V2-RL-BO-014-C02",
        "familyId": "NDR-V2-RL-BO-014",
        "label": "Linen",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-014-c02",
        "weaveDetailMediaKey": "weave-rl-bo-014-c02"
      },
      {
        "id": "NDR-V2-RL-BO-014-C03",
        "familyId": "NDR-V2-RL-BO-014",
        "label": "Azure",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-014-c03",
        "weaveDetailMediaKey": "weave-rl-bo-014-c03"
      },
      {
        "id": "NDR-V2-RL-BO-014-C04",
        "familyId": "NDR-V2-RL-BO-014",
        "label": "Soft White",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-014-c04",
        "weaveDetailMediaKey": "weave-rl-bo-014-c04"
      },
      {
        "id": "NDR-V2-RL-BO-014-C05",
        "familyId": "NDR-V2-RL-BO-014",
        "label": "Oyster",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-014-c05",
        "weaveDetailMediaKey": "weave-rl-bo-014-c05"
      },
      {
        "id": "NDR-V2-RL-BO-015-C01",
        "familyId": "NDR-V2-RL-BO-015",
        "label": "Sky",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-015-c01",
        "weaveDetailMediaKey": "weave-rl-bo-015-c01"
      },
      {
        "id": "NDR-V2-RL-BO-015-C02",
        "familyId": "NDR-V2-RL-BO-015",
        "label": "Silver",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-015-c02",
        "weaveDetailMediaKey": "weave-rl-bo-015-c02"
      },
      {
        "id": "NDR-V2-RL-BO-015-C03",
        "familyId": "NDR-V2-RL-BO-015",
        "label": "Graphite",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-015-c03",
        "weaveDetailMediaKey": "weave-rl-bo-015-c03"
      },
      {
        "id": "NDR-V2-RL-BO-015-C04",
        "familyId": "NDR-V2-RL-BO-015",
        "label": "Espresso",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-015-c04",
        "weaveDetailMediaKey": "weave-rl-bo-015-c04"
      },
      {
        "id": "NDR-V2-RL-BO-016-C01",
        "familyId": "NDR-V2-RL-BO-016",
        "label": "Cloud White",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-016-c01",
        "weaveDetailMediaKey": "weave-rl-bo-016-c01"
      },
      {
        "id": "NDR-V2-RL-BO-016-C02",
        "familyId": "NDR-V2-RL-BO-016",
        "label": "Natural Linen",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-rl-bo-016-c02",
        "weaveDetailMediaKey": "weave-rl-bo-016-c02"
      },
      {
        "id": "NDR-V2-RL-LF-001-C01",
        "familyId": "NDR-V2-RL-LF-001",
        "label": "Coastal White",
        "fabricType": "light-filtering",
        "selectorMediaKey": "fabric-rl-lf-001-c01",
        "weaveDetailMediaKey": "weave-rl-lf-001-c01"
      },
      {
        "id": "NDR-V2-RL-LF-001-C02",
        "familyId": "NDR-V2-RL-LF-001",
        "label": "Oyster",
        "fabricType": "light-filtering",
        "selectorMediaKey": "fabric-rl-lf-001-c02",
        "weaveDetailMediaKey": "weave-rl-lf-001-c02"
      },
      {
        "id": "NDR-V2-RL-LF-001-C03",
        "familyId": "NDR-V2-RL-LF-001",
        "label": "Sandbar",
        "fabricType": "light-filtering",
        "selectorMediaKey": "fabric-rl-lf-001-c03",
        "weaveDetailMediaKey": "weave-rl-lf-001-c03"
      },
      {
        "id": "NDR-V2-RL-LF-001-C04",
        "familyId": "NDR-V2-RL-LF-001",
        "label": "Graphite",
        "fabricType": "light-filtering",
        "selectorMediaKey": "fabric-rl-lf-001-c04",
        "weaveDetailMediaKey": "weave-rl-lf-001-c04"
      },
      {
        "id": "NDR-V2-RL-LF-001-C05",
        "familyId": "NDR-V2-RL-LF-001",
        "label": "Driftwood",
        "fabricType": "light-filtering",
        "selectorMediaKey": "fabric-rl-lf-001-c05",
        "weaveDetailMediaKey": "weave-rl-lf-001-c05"
      },
      {
        "id": "NDR-V2-RL-LF-002-C01",
        "familyId": "NDR-V2-RL-LF-002",
        "label": "Graphic White",
        "fabricType": "light-filtering",
        "selectorMediaKey": "fabric-rl-lf-002-c01",
        "weaveDetailMediaKey": "weave-rl-lf-002-c01"
      },
      {
        "id": "NDR-V2-RL-LF-002-C02",
        "familyId": "NDR-V2-RL-LF-002",
        "label": "Soft White",
        "fabricType": "light-filtering",
        "selectorMediaKey": "fabric-rl-lf-002-c02",
        "weaveDetailMediaKey": "weave-rl-lf-002-c02"
      },
      {
        "id": "NDR-V2-RL-LF-002-C03",
        "familyId": "NDR-V2-RL-LF-002",
        "label": "Silver Mosaic",
        "fabricType": "light-filtering",
        "selectorMediaKey": "fabric-rl-lf-002-c03",
        "weaveDetailMediaKey": "weave-rl-lf-002-c03"
      },
      {
        "id": "NDR-V2-RL-LF-002-C04",
        "familyId": "NDR-V2-RL-LF-002",
        "label": "Graphite Mosaic",
        "fabricType": "light-filtering",
        "selectorMediaKey": "fabric-rl-lf-002-c04",
        "weaveDetailMediaKey": "weave-rl-lf-002-c04"
      },
      {
        "id": "NDR-V2-RL-LF-002-C05",
        "familyId": "NDR-V2-RL-LF-002",
        "label": "Onyx Mosaic",
        "fabricType": "light-filtering",
        "selectorMediaKey": "fabric-rl-lf-002-c05",
        "weaveDetailMediaKey": "weave-rl-lf-002-c05"
      },
      {
        "id": "NDR-V2-RL-LF-003-C01",
        "familyId": "NDR-V2-RL-LF-003",
        "label": "Cloud White",
        "fabricType": "light-filtering",
        "selectorMediaKey": "fabric-rl-lf-003-c01",
        "weaveDetailMediaKey": "weave-rl-lf-003-c01"
      },
      {
        "id": "NDR-V2-RL-LF-003-C02",
        "familyId": "NDR-V2-RL-LF-003",
        "label": "Oyster",
        "fabricType": "light-filtering",
        "selectorMediaKey": "fabric-rl-lf-003-c02",
        "weaveDetailMediaKey": "weave-rl-lf-003-c02"
      },
      {
        "id": "NDR-V2-RL-LF-003-C03",
        "familyId": "NDR-V2-RL-LF-003",
        "label": "Linen",
        "fabricType": "light-filtering",
        "selectorMediaKey": "fabric-rl-lf-003-c03",
        "weaveDetailMediaKey": "weave-rl-lf-003-c03"
      },
      {
        "id": "NDR-V2-RL-LF-003-C04",
        "familyId": "NDR-V2-RL-LF-003",
        "label": "Silver",
        "fabricType": "light-filtering",
        "selectorMediaKey": "fabric-rl-lf-003-c04",
        "weaveDetailMediaKey": "weave-rl-lf-003-c04"
      },
      {
        "id": "NDR-V2-RL-LF-003-C05",
        "familyId": "NDR-V2-RL-LF-003",
        "label": "Graphite",
        "fabricType": "light-filtering",
        "selectorMediaKey": "fabric-rl-lf-003-c05",
        "weaveDetailMediaKey": "weave-rl-lf-003-c05"
      },
      {
        "id": "NDR-V2-RL-LF-003-C06",
        "familyId": "NDR-V2-RL-LF-003",
        "label": "Onyx",
        "fabricType": "light-filtering",
        "selectorMediaKey": "fabric-rl-lf-003-c06",
        "weaveDetailMediaKey": "weave-rl-lf-003-c06"
      },
      {
        "id": "NDR-V2-RL-LF-004-C01",
        "familyId": "NDR-V2-RL-LF-004",
        "label": "Cloud White",
        "fabricType": "light-filtering",
        "selectorMediaKey": "fabric-rl-lf-004-c01",
        "weaveDetailMediaKey": "weave-rl-lf-004-c01"
      },
      {
        "id": "NDR-V2-RL-LF-004-C02",
        "familyId": "NDR-V2-RL-LF-004",
        "label": "Oatmeal",
        "fabricType": "light-filtering",
        "selectorMediaKey": "fabric-rl-lf-004-c02",
        "weaveDetailMediaKey": "weave-rl-lf-004-c02"
      },
      {
        "id": "NDR-V2-RL-LF-004-C03",
        "familyId": "NDR-V2-RL-LF-004",
        "label": "Silver",
        "fabricType": "light-filtering",
        "selectorMediaKey": "fabric-rl-lf-004-c03",
        "weaveDetailMediaKey": "weave-rl-lf-004-c03"
      },
      {
        "id": "NDR-V2-RL-LF-004-C04",
        "familyId": "NDR-V2-RL-LF-004",
        "label": "Pewter",
        "fabricType": "light-filtering",
        "selectorMediaKey": "fabric-rl-lf-004-c04",
        "weaveDetailMediaKey": "weave-rl-lf-004-c04"
      },
      {
        "id": "NDR-V2-RL-LF-004-C05",
        "familyId": "NDR-V2-RL-LF-004",
        "label": "Graphite",
        "fabricType": "light-filtering",
        "selectorMediaKey": "fabric-rl-lf-004-c05",
        "weaveDetailMediaKey": "weave-rl-lf-004-c05"
      },
      {
        "id": "NDR-V2-RL-LF-004-C06",
        "familyId": "NDR-V2-RL-LF-004",
        "label": "Charcoal",
        "fabricType": "light-filtering",
        "selectorMediaKey": "fabric-rl-lf-004-c06",
        "weaveDetailMediaKey": "weave-rl-lf-004-c06"
      },
      {
        "id": "NDR-V2-RL-LF-004-C07",
        "familyId": "NDR-V2-RL-LF-004",
        "label": "Onyx",
        "fabricType": "light-filtering",
        "selectorMediaKey": "fabric-rl-lf-004-c07",
        "weaveDetailMediaKey": "weave-rl-lf-004-c07"
      },
      {
        "id": "NDR-V2-RL-LF-005-C01",
        "familyId": "NDR-V2-RL-LF-005",
        "label": "Cloud White",
        "fabricType": "light-filtering",
        "selectorMediaKey": "fabric-rl-lf-005-c01",
        "weaveDetailMediaKey": "weave-rl-lf-005-c01"
      },
      {
        "id": "NDR-V2-RL-LF-005-C02",
        "familyId": "NDR-V2-RL-LF-005",
        "label": "Oatmeal",
        "fabricType": "light-filtering",
        "selectorMediaKey": "fabric-rl-lf-005-c02",
        "weaveDetailMediaKey": "weave-rl-lf-005-c02"
      },
      {
        "id": "NDR-V2-RL-LF-005-C03",
        "familyId": "NDR-V2-RL-LF-005",
        "label": "Taupe",
        "fabricType": "light-filtering",
        "selectorMediaKey": "fabric-rl-lf-005-c03",
        "weaveDetailMediaKey": "weave-rl-lf-005-c03"
      },
      {
        "id": "NDR-V2-RL-LF-005-C04",
        "familyId": "NDR-V2-RL-LF-005",
        "label": "Silver",
        "fabricType": "light-filtering",
        "selectorMediaKey": "fabric-rl-lf-005-c04",
        "weaveDetailMediaKey": "weave-rl-lf-005-c04"
      },
      {
        "id": "NDR-V2-RL-LF-005-C05",
        "familyId": "NDR-V2-RL-LF-005",
        "label": "Pewter",
        "fabricType": "light-filtering",
        "selectorMediaKey": "fabric-rl-lf-005-c05",
        "weaveDetailMediaKey": "weave-rl-lf-005-c05"
      },
      {
        "id": "NDR-V2-RL-LF-005-C06",
        "familyId": "NDR-V2-RL-LF-005",
        "label": "Graphite",
        "fabricType": "light-filtering",
        "selectorMediaKey": "fabric-rl-lf-005-c06",
        "weaveDetailMediaKey": "weave-rl-lf-005-c06"
      },
      {
        "id": "NDR-V2-RL-LF-005-C07",
        "familyId": "NDR-V2-RL-LF-005",
        "label": "Onyx",
        "fabricType": "light-filtering",
        "selectorMediaKey": "fabric-rl-lf-005-c07",
        "weaveDetailMediaKey": "weave-rl-lf-005-c07"
      },
      {
        "id": "NDR-V2-RL-LF-006-C01",
        "familyId": "NDR-V2-RL-LF-006",
        "label": "Linen",
        "fabricType": "light-filtering",
        "selectorMediaKey": "fabric-rl-lf-006-c01",
        "weaveDetailMediaKey": "weave-rl-lf-006-c01"
      },
      {
        "id": "NDR-V2-RL-LF-006-C02",
        "familyId": "NDR-V2-RL-LF-006",
        "label": "Silver",
        "fabricType": "light-filtering",
        "selectorMediaKey": "fabric-rl-lf-006-c02",
        "weaveDetailMediaKey": "weave-rl-lf-006-c02"
      },
      {
        "id": "NDR-V2-RL-LF-006-C03",
        "familyId": "NDR-V2-RL-LF-006",
        "label": "Blue Gray",
        "fabricType": "light-filtering",
        "selectorMediaKey": "fabric-rl-lf-006-c03",
        "weaveDetailMediaKey": "weave-rl-lf-006-c03"
      },
      {
        "id": "NDR-V2-RL-LF-006-C04",
        "familyId": "NDR-V2-RL-LF-006",
        "label": "Slate",
        "fabricType": "light-filtering",
        "selectorMediaKey": "fabric-rl-lf-006-c04",
        "weaveDetailMediaKey": "weave-rl-lf-006-c04"
      },
      {
        "id": "NDR-V2-RL-LF-007-C01",
        "familyId": "NDR-V2-RL-LF-007",
        "label": "Aqua",
        "fabricType": "light-filtering",
        "selectorMediaKey": "fabric-rl-lf-007-c01",
        "weaveDetailMediaKey": "weave-rl-lf-007-c01"
      },
      {
        "id": "NDR-V2-RL-LF-007-C02",
        "familyId": "NDR-V2-RL-LF-007",
        "label": "Taupe",
        "fabricType": "light-filtering",
        "selectorMediaKey": "fabric-rl-lf-007-c02",
        "weaveDetailMediaKey": "weave-rl-lf-007-c02"
      },
      {
        "id": "NDR-V2-RL-LF-007-C03",
        "familyId": "NDR-V2-RL-LF-007",
        "label": "Silver",
        "fabricType": "light-filtering",
        "selectorMediaKey": "fabric-rl-lf-007-c03",
        "weaveDetailMediaKey": "weave-rl-lf-007-c03"
      },
      {
        "id": "NDR-V2-RL-LF-007-C04",
        "familyId": "NDR-V2-RL-LF-007",
        "label": "Linen",
        "fabricType": "light-filtering",
        "selectorMediaKey": "fabric-rl-lf-007-c04",
        "weaveDetailMediaKey": "weave-rl-lf-007-c04"
      },
      {
        "id": "NDR-V2-RL-LF-007-C05",
        "familyId": "NDR-V2-RL-LF-007",
        "label": "Olive",
        "fabricType": "light-filtering",
        "selectorMediaKey": "fabric-rl-lf-007-c05",
        "weaveDetailMediaKey": "weave-rl-lf-007-c05"
      },
      {
        "id": "NDR-V2-RL-LF-008-C01",
        "familyId": "NDR-V2-RL-LF-008",
        "label": "Cloud White",
        "fabricType": "light-filtering",
        "selectorMediaKey": "fabric-rl-lf-008-c01",
        "weaveDetailMediaKey": "weave-rl-lf-008-c01"
      },
      {
        "id": "NDR-V2-RL-LF-008-C02",
        "familyId": "NDR-V2-RL-LF-008",
        "label": "Cream",
        "fabricType": "light-filtering",
        "selectorMediaKey": "fabric-rl-lf-008-c02",
        "weaveDetailMediaKey": "weave-rl-lf-008-c02"
      },
      {
        "id": "NDR-V2-RL-LF-008-C03",
        "familyId": "NDR-V2-RL-LF-008",
        "label": "Taupe",
        "fabricType": "light-filtering",
        "selectorMediaKey": "fabric-rl-lf-008-c03",
        "weaveDetailMediaKey": "weave-rl-lf-008-c03"
      },
      {
        "id": "NDR-V2-RL-LF-008-C04",
        "familyId": "NDR-V2-RL-LF-008",
        "label": "Silver",
        "fabricType": "light-filtering",
        "selectorMediaKey": "fabric-rl-lf-008-c04",
        "weaveDetailMediaKey": "weave-rl-lf-008-c04"
      },
      {
        "id": "NDR-V2-RL-LF-008-C05",
        "familyId": "NDR-V2-RL-LF-008",
        "label": "Azure",
        "fabricType": "light-filtering",
        "selectorMediaKey": "fabric-rl-lf-008-c05",
        "weaveDetailMediaKey": "weave-rl-lf-008-c05"
      },
      {
        "id": "NDR-V2-RL-LF-008-C06",
        "familyId": "NDR-V2-RL-LF-008",
        "label": "Sky",
        "fabricType": "light-filtering",
        "selectorMediaKey": "fabric-rl-lf-008-c06",
        "weaveDetailMediaKey": "weave-rl-lf-008-c06"
      },
      {
        "id": "NDR-V2-RL-LF-009-C01",
        "familyId": "NDR-V2-RL-LF-009",
        "label": "Pearl White",
        "fabricType": "light-filtering",
        "selectorMediaKey": "fabric-rl-lf-009-c01",
        "weaveDetailMediaKey": "weave-rl-lf-009-c01"
      },
      {
        "id": "NDR-V2-RL-LF-009-C02",
        "familyId": "NDR-V2-RL-LF-009",
        "label": "Natural Linen",
        "fabricType": "light-filtering",
        "selectorMediaKey": "fabric-rl-lf-009-c02",
        "weaveDetailMediaKey": "weave-rl-lf-009-c02"
      },
      {
        "id": "NDR-V2-RL-SO-001-C01",
        "familyId": "NDR-V2-RL-SO-001",
        "label": "Cloud",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-001-c01",
        "weaveDetailMediaKey": "weave-rl-so-001-c01",
        "opennessFactorPct": 1
      },
      {
        "id": "NDR-V2-RL-SO-001-C02",
        "familyId": "NDR-V2-RL-SO-001",
        "label": "Linen",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-001-c02",
        "weaveDetailMediaKey": "weave-rl-so-001-c02",
        "opennessFactorPct": 1
      },
      {
        "id": "NDR-V2-RL-SO-001-C03",
        "familyId": "NDR-V2-RL-SO-001",
        "label": "Silver",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-001-c03",
        "weaveDetailMediaKey": "weave-rl-so-001-c03",
        "opennessFactorPct": 1
      },
      {
        "id": "NDR-V2-RL-SO-001-C04",
        "familyId": "NDR-V2-RL-SO-001",
        "label": "Graphite",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-001-c04",
        "weaveDetailMediaKey": "weave-rl-so-001-c04",
        "opennessFactorPct": 1
      },
      {
        "id": "NDR-V2-RL-SO-105-C01",
        "familyId": "NDR-V2-RL-SO-105",
        "label": "Cloud",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-105-c01",
        "weaveDetailMediaKey": "weave-rl-so-105-c01",
        "opennessFactorPct": 1
      },
      {
        "id": "NDR-V2-RL-SO-105-C02",
        "familyId": "NDR-V2-RL-SO-105",
        "label": "Linen",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-105-c02",
        "weaveDetailMediaKey": "weave-rl-so-105-c02",
        "opennessFactorPct": 1
      },
      {
        "id": "NDR-V2-RL-SO-105-C03",
        "familyId": "NDR-V2-RL-SO-105",
        "label": "Silver",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-105-c03",
        "weaveDetailMediaKey": "weave-rl-so-105-c03",
        "opennessFactorPct": 1
      },
      {
        "id": "NDR-V2-RL-SO-105-C04",
        "familyId": "NDR-V2-RL-SO-105",
        "label": "Espresso",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-105-c04",
        "weaveDetailMediaKey": "weave-rl-so-105-c04",
        "opennessFactorPct": 1
      },
      {
        "id": "NDR-V2-RL-SO-105-C05",
        "familyId": "NDR-V2-RL-SO-105",
        "label": "Graphite",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-105-c05",
        "weaveDetailMediaKey": "weave-rl-so-105-c05",
        "opennessFactorPct": 1
      },
      {
        "id": "NDR-V2-RL-SO-105-C06",
        "familyId": "NDR-V2-RL-SO-105",
        "label": "Onyx",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-105-c06",
        "weaveDetailMediaKey": "weave-rl-so-105-c06",
        "opennessFactorPct": 1
      },
      {
        "id": "NDR-V2-RL-SO-003-C01",
        "familyId": "NDR-V2-RL-SO-003",
        "label": "Cloud",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-003-c01",
        "weaveDetailMediaKey": "weave-rl-so-003-c01",
        "opennessFactorPct": 3
      },
      {
        "id": "NDR-V2-RL-SO-003-C02",
        "familyId": "NDR-V2-RL-SO-003",
        "label": "Linen",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-003-c02",
        "weaveDetailMediaKey": "weave-rl-so-003-c02",
        "opennessFactorPct": 3
      },
      {
        "id": "NDR-V2-RL-SO-003-C03",
        "familyId": "NDR-V2-RL-SO-003",
        "label": "Pewter",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-003-c03",
        "weaveDetailMediaKey": "weave-rl-so-003-c03",
        "opennessFactorPct": 3
      },
      {
        "id": "NDR-V2-RL-SO-003-C04",
        "familyId": "NDR-V2-RL-SO-003",
        "label": "Charcoal",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-003-c04",
        "weaveDetailMediaKey": "weave-rl-so-003-c04",
        "opennessFactorPct": 3
      },
      {
        "id": "NDR-V2-RL-SO-103-C01",
        "familyId": "NDR-V2-RL-SO-103",
        "label": "Cloud",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-103-c01",
        "weaveDetailMediaKey": "weave-rl-so-103-c01",
        "opennessFactorPct": 3
      },
      {
        "id": "NDR-V2-RL-SO-103-C02",
        "familyId": "NDR-V2-RL-SO-103",
        "label": "Linen",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-103-c02",
        "weaveDetailMediaKey": "weave-rl-so-103-c02",
        "opennessFactorPct": 3
      },
      {
        "id": "NDR-V2-RL-SO-103-C03",
        "familyId": "NDR-V2-RL-SO-103",
        "label": "Silver",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-103-c03",
        "weaveDetailMediaKey": "weave-rl-so-103-c03",
        "opennessFactorPct": 3
      },
      {
        "id": "NDR-V2-RL-SO-104-C01",
        "familyId": "NDR-V2-RL-SO-104",
        "label": "Cloud",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-104-c01",
        "weaveDetailMediaKey": "weave-rl-so-104-c01",
        "opennessFactorPct": 3
      },
      {
        "id": "NDR-V2-RL-SO-104-C02",
        "familyId": "NDR-V2-RL-SO-104",
        "label": "Linen",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-104-c02",
        "weaveDetailMediaKey": "weave-rl-so-104-c02",
        "opennessFactorPct": 3
      },
      {
        "id": "NDR-V2-RL-SO-104-C03",
        "familyId": "NDR-V2-RL-SO-104",
        "label": "Silver",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-104-c03",
        "weaveDetailMediaKey": "weave-rl-so-104-c03",
        "opennessFactorPct": 3
      },
      {
        "id": "NDR-V2-RL-SO-104-C04",
        "familyId": "NDR-V2-RL-SO-104",
        "label": "Sandbar",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-104-c04",
        "weaveDetailMediaKey": "weave-rl-so-104-c04",
        "opennessFactorPct": 3
      },
      {
        "id": "NDR-V2-RL-SO-104-C05",
        "familyId": "NDR-V2-RL-SO-104",
        "label": "Mist",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-104-c05",
        "weaveDetailMediaKey": "weave-rl-so-104-c05",
        "opennessFactorPct": 3
      },
      {
        "id": "NDR-V2-RL-SO-104-C06",
        "familyId": "NDR-V2-RL-SO-104",
        "label": "Espresso",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-104-c06",
        "weaveDetailMediaKey": "weave-rl-so-104-c06",
        "opennessFactorPct": 3
      },
      {
        "id": "NDR-V2-RL-SO-104-C07",
        "familyId": "NDR-V2-RL-SO-104",
        "label": "Graphite",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-104-c07",
        "weaveDetailMediaKey": "weave-rl-so-104-c07",
        "opennessFactorPct": 3
      },
      {
        "id": "NDR-V2-RL-SO-104-C08",
        "familyId": "NDR-V2-RL-SO-104",
        "label": "Onyx",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-104-c08",
        "weaveDetailMediaKey": "weave-rl-so-104-c08",
        "opennessFactorPct": 3
      },
      {
        "id": "NDR-V2-RL-SO-108-C01",
        "familyId": "NDR-V2-RL-SO-108",
        "label": "Cloud",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-108-c01",
        "weaveDetailMediaKey": "weave-rl-so-108-c01",
        "opennessFactorPct": 3
      },
      {
        "id": "NDR-V2-RL-SO-108-C02",
        "familyId": "NDR-V2-RL-SO-108",
        "label": "Linen",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-108-c02",
        "weaveDetailMediaKey": "weave-rl-so-108-c02",
        "opennessFactorPct": 3
      },
      {
        "id": "NDR-V2-RL-SO-108-C03",
        "familyId": "NDR-V2-RL-SO-108",
        "label": "Silver",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-108-c03",
        "weaveDetailMediaKey": "weave-rl-so-108-c03",
        "opennessFactorPct": 3
      },
      {
        "id": "NDR-V2-RL-SO-108-C04",
        "familyId": "NDR-V2-RL-SO-108",
        "label": "Lagoon",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-108-c04",
        "weaveDetailMediaKey": "weave-rl-so-108-c04",
        "opennessFactorPct": 3
      },
      {
        "id": "NDR-V2-RL-SO-108-C05",
        "familyId": "NDR-V2-RL-SO-108",
        "label": "Graphite",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-108-c05",
        "weaveDetailMediaKey": "weave-rl-so-108-c05",
        "opennessFactorPct": 3
      },
      {
        "id": "NDR-V2-RL-SO-108-C06",
        "familyId": "NDR-V2-RL-SO-108",
        "label": "Onyx",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-108-c06",
        "weaveDetailMediaKey": "weave-rl-so-108-c06",
        "opennessFactorPct": 3
      },
      {
        "id": "NDR-V2-RL-SO-005-C01",
        "familyId": "NDR-V2-RL-SO-005",
        "label": "Cloud",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-005-c01",
        "weaveDetailMediaKey": "weave-rl-so-005-c01",
        "opennessFactorPct": 5
      },
      {
        "id": "NDR-V2-RL-SO-005-C02",
        "familyId": "NDR-V2-RL-SO-005",
        "label": "Silver",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-005-c02",
        "weaveDetailMediaKey": "weave-rl-so-005-c02",
        "opennessFactorPct": 5
      },
      {
        "id": "NDR-V2-RL-SO-005-C03",
        "familyId": "NDR-V2-RL-SO-005",
        "label": "Slate",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-005-c03",
        "weaveDetailMediaKey": "weave-rl-so-005-c03",
        "opennessFactorPct": 5
      },
      {
        "id": "NDR-V2-RL-SO-005-C04",
        "familyId": "NDR-V2-RL-SO-005",
        "label": "Charcoal",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-005-c04",
        "weaveDetailMediaKey": "weave-rl-so-005-c04",
        "opennessFactorPct": 5
      },
      {
        "id": "NDR-V2-RL-SO-005-C05",
        "familyId": "NDR-V2-RL-SO-005",
        "label": "Bronze",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-005-c05",
        "weaveDetailMediaKey": "weave-rl-so-005-c05",
        "opennessFactorPct": 5
      },
      {
        "id": "NDR-V2-RL-SO-101-C01",
        "familyId": "NDR-V2-RL-SO-101",
        "label": "Cloud",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-101-c01",
        "weaveDetailMediaKey": "weave-rl-so-101-c01",
        "opennessFactorPct": 5
      },
      {
        "id": "NDR-V2-RL-SO-101-C02",
        "familyId": "NDR-V2-RL-SO-101",
        "label": "Linen",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-101-c02",
        "weaveDetailMediaKey": "weave-rl-so-101-c02",
        "opennessFactorPct": 5
      },
      {
        "id": "NDR-V2-RL-SO-101-C03",
        "familyId": "NDR-V2-RL-SO-101",
        "label": "Silver",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-101-c03",
        "weaveDetailMediaKey": "weave-rl-so-101-c03",
        "opennessFactorPct": 5
      },
      {
        "id": "NDR-V2-RL-SO-101-C04",
        "familyId": "NDR-V2-RL-SO-101",
        "label": "Sandbar",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-101-c04",
        "weaveDetailMediaKey": "weave-rl-so-101-c04",
        "opennessFactorPct": 5
      },
      {
        "id": "NDR-V2-RL-SO-101-C05",
        "familyId": "NDR-V2-RL-SO-101",
        "label": "Mist",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-101-c05",
        "weaveDetailMediaKey": "weave-rl-so-101-c05",
        "opennessFactorPct": 5
      },
      {
        "id": "NDR-V2-RL-SO-101-C06",
        "familyId": "NDR-V2-RL-SO-101",
        "label": "Pewter",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-101-c06",
        "weaveDetailMediaKey": "weave-rl-so-101-c06",
        "opennessFactorPct": 5
      },
      {
        "id": "NDR-V2-RL-SO-101-C07",
        "familyId": "NDR-V2-RL-SO-101",
        "label": "Espresso",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-101-c07",
        "weaveDetailMediaKey": "weave-rl-so-101-c07",
        "opennessFactorPct": 5
      },
      {
        "id": "NDR-V2-RL-SO-101-C08",
        "familyId": "NDR-V2-RL-SO-101",
        "label": "Graphite",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-101-c08",
        "weaveDetailMediaKey": "weave-rl-so-101-c08",
        "opennessFactorPct": 5
      },
      {
        "id": "NDR-V2-RL-SO-101-C09",
        "familyId": "NDR-V2-RL-SO-101",
        "label": "Onyx",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-101-c09",
        "weaveDetailMediaKey": "weave-rl-so-101-c09",
        "opennessFactorPct": 5
      },
      {
        "id": "NDR-V2-RL-SO-102-C01",
        "familyId": "NDR-V2-RL-SO-102",
        "label": "Cloud",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-102-c01",
        "weaveDetailMediaKey": "weave-rl-so-102-c01",
        "opennessFactorPct": 5
      },
      {
        "id": "NDR-V2-RL-SO-102-C02",
        "familyId": "NDR-V2-RL-SO-102",
        "label": "Oyster",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-102-c02",
        "weaveDetailMediaKey": "weave-rl-so-102-c02",
        "opennessFactorPct": 5
      },
      {
        "id": "NDR-V2-RL-SO-102-C03",
        "familyId": "NDR-V2-RL-SO-102",
        "label": "Silver",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-102-c03",
        "weaveDetailMediaKey": "weave-rl-so-102-c03",
        "opennessFactorPct": 5
      },
      {
        "id": "NDR-V2-RL-SO-102-C04",
        "familyId": "NDR-V2-RL-SO-102",
        "label": "Sandbar",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-102-c04",
        "weaveDetailMediaKey": "weave-rl-so-102-c04",
        "opennessFactorPct": 5
      },
      {
        "id": "NDR-V2-RL-SO-102-C05",
        "familyId": "NDR-V2-RL-SO-102",
        "label": "Mist",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-102-c05",
        "weaveDetailMediaKey": "weave-rl-so-102-c05",
        "opennessFactorPct": 5
      },
      {
        "id": "NDR-V2-RL-SO-102-C06",
        "familyId": "NDR-V2-RL-SO-102",
        "label": "Slate",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-102-c06",
        "weaveDetailMediaKey": "weave-rl-so-102-c06",
        "opennessFactorPct": 5
      },
      {
        "id": "NDR-V2-RL-SO-102-C07",
        "familyId": "NDR-V2-RL-SO-102",
        "label": "Charcoal",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-102-c07",
        "weaveDetailMediaKey": "weave-rl-so-102-c07",
        "opennessFactorPct": 5
      },
      {
        "id": "NDR-V2-RL-SO-102-C08",
        "familyId": "NDR-V2-RL-SO-102",
        "label": "Graphite",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-102-c08",
        "weaveDetailMediaKey": "weave-rl-so-102-c08",
        "opennessFactorPct": 5
      },
      {
        "id": "NDR-V2-RL-SO-102-C09",
        "familyId": "NDR-V2-RL-SO-102",
        "label": "Onyx",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-102-c09",
        "weaveDetailMediaKey": "weave-rl-so-102-c09",
        "opennessFactorPct": 5
      },
      {
        "id": "NDR-V2-RL-SO-106-C01",
        "familyId": "NDR-V2-RL-SO-106",
        "label": "Cloud",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-106-c01",
        "weaveDetailMediaKey": "weave-rl-so-106-c01",
        "opennessFactorPct": 5
      },
      {
        "id": "NDR-V2-RL-SO-106-C02",
        "familyId": "NDR-V2-RL-SO-106",
        "label": "Linen",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-106-c02",
        "weaveDetailMediaKey": "weave-rl-so-106-c02",
        "opennessFactorPct": 5
      },
      {
        "id": "NDR-V2-RL-SO-106-C03",
        "familyId": "NDR-V2-RL-SO-106",
        "label": "Silver",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-106-c03",
        "weaveDetailMediaKey": "weave-rl-so-106-c03",
        "opennessFactorPct": 5
      },
      {
        "id": "NDR-V2-RL-SO-109-C01",
        "familyId": "NDR-V2-RL-SO-109",
        "label": "Cloud",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-109-c01",
        "opennessFactorPct": 0
      },
      {
        "id": "NDR-V2-RL-SO-109-C02",
        "familyId": "NDR-V2-RL-SO-109",
        "label": "Linen",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-109-c02",
        "opennessFactorPct": 0
      },
      {
        "id": "NDR-V2-RL-SO-109-C03",
        "familyId": "NDR-V2-RL-SO-109",
        "label": "Silver",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-109-c03",
        "opennessFactorPct": 0
      },
      {
        "id": "NDR-V2-RL-SO-107-C01",
        "familyId": "NDR-V2-RL-SO-107",
        "label": "Cloud",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-107-c01",
        "weaveDetailMediaKey": "weave-rl-so-107-c01",
        "opennessFactorPct": 6
      },
      {
        "id": "NDR-V2-RL-SO-107-C02",
        "familyId": "NDR-V2-RL-SO-107",
        "label": "Linen",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-107-c02",
        "weaveDetailMediaKey": "weave-rl-so-107-c02",
        "opennessFactorPct": 6
      },
      {
        "id": "NDR-V2-RL-SO-107-C03",
        "familyId": "NDR-V2-RL-SO-107",
        "label": "Silver",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-107-c03",
        "weaveDetailMediaKey": "weave-rl-so-107-c03",
        "opennessFactorPct": 6
      },
      {
        "id": "NDR-V2-RL-SO-107-C04",
        "familyId": "NDR-V2-RL-SO-107",
        "label": "Coral",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-107-c04",
        "weaveDetailMediaKey": "weave-rl-so-107-c04",
        "opennessFactorPct": 6
      },
      {
        "id": "NDR-V2-RL-SO-107-C05",
        "familyId": "NDR-V2-RL-SO-107",
        "label": "Mangrove",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-107-c05",
        "weaveDetailMediaKey": "weave-rl-so-107-c05",
        "opennessFactorPct": 6
      },
      {
        "id": "NDR-V2-RL-SO-107-C06",
        "familyId": "NDR-V2-RL-SO-107",
        "label": "Charcoal",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-107-c06",
        "weaveDetailMediaKey": "weave-rl-so-107-c06",
        "opennessFactorPct": 6
      },
      {
        "id": "NDR-V2-RL-SO-107-C07",
        "familyId": "NDR-V2-RL-SO-107",
        "label": "Graphite",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-107-c07",
        "weaveDetailMediaKey": "weave-rl-so-107-c07",
        "opennessFactorPct": 6
      },
      {
        "id": "NDR-V2-RL-SO-107-C08",
        "familyId": "NDR-V2-RL-SO-107",
        "label": "Onyx",
        "fabricType": "solar",
        "selectorMediaKey": "fabric-rl-so-107-c08",
        "weaveDetailMediaKey": "weave-rl-so-107-c08",
        "opennessFactorPct": 6
      }
    ]
  },
  "zebra": {
    "families": [
      {
        "id": "NDR-V2-ZB-BO-002",
        "label": "Biscayne Zebra Blackout",
        "fabricTypes": [
          "blackout"
        ],
        "representativeMediaKey": "fabric-zb-bo-002-c01",
        "roomMediaKey": "room-zb-bo-002",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 5,
        "visualVariantCount": 5,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "classic-clean",
          "groupLabel": "Classic & Clean",
          "groupOrder": 1,
          "navigationState": "available"
        }
      },
      {
        "id": "NDR-V2-ZB-BO-003",
        "label": "Atlantic Linen Zebra Blackout",
        "fabricTypes": [
          "blackout"
        ],
        "representativeMediaKey": "fabric-zb-bo-003-c01",
        "roomMediaKey": "room-zb-bo-003",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 6,
        "visualVariantCount": 6,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "linen-woven",
          "groupLabel": "Linen & Woven",
          "groupOrder": 2,
          "navigationState": "available"
        }
      },
      {
        "id": "NDR-V2-ZB-BO-004",
        "label": "Coral Ridge Zebra Blackout",
        "fabricTypes": [
          "blackout"
        ],
        "representativeMediaKey": "fabric-zb-bo-004-c01",
        "roomMediaKey": "room-zb-bo-004",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 7,
        "visualVariantCount": 7,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "linen-woven",
          "groupLabel": "Linen & Woven",
          "groupOrder": 2,
          "navigationState": "available"
        }
      },
      {
        "id": "NDR-V2-ZB-BO-001",
        "label": "Riviera Textured Blackout",
        "fabricTypes": [
          "blackout"
        ],
        "representativeMediaKey": "fabric-zb-bo-001-c01",
        "roomMediaKey": "room-zb-bo-001",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 7,
        "visualVariantCount": 7,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "classic-clean",
          "groupLabel": "Classic & Clean",
          "groupOrder": 1,
          "navigationState": "available"
        }
      },
      {
        "id": "NDR-V2-ZB-SB-002",
        "label": "Ocean Drive Zebra Semi-Blackout",
        "fabricTypes": [
          "semi-blackout"
        ],
        "representativeMediaKey": "fabric-zb-sb-002-c01",
        "roomMediaKey": "room-zb-sb-002",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 7,
        "visualVariantCount": 7,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "classic-clean",
          "groupLabel": "Classic & Clean",
          "groupOrder": 1,
          "navigationState": "available"
        }
      },
      {
        "id": "NDR-V2-ZB-BO-005",
        "label": "Las Olas Linear Zebra Blackout",
        "fabricTypes": [
          "blackout"
        ],
        "representativeMediaKey": "fabric-zb-bo-005-c01",
        "roomMediaKey": "room-zb-bo-005",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 5,
        "visualVariantCount": 5,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "linear-silky",
          "groupLabel": "Linear & Silky",
          "groupOrder": 3,
          "navigationState": "available"
        }
      },
      {
        "id": "NDR-V2-ZB-BO-006",
        "label": "Intracoastal Zebra Blackout",
        "fabricTypes": [
          "blackout"
        ],
        "representativeMediaKey": "fabric-zb-bo-006-c01",
        "roomMediaKey": "room-zb-bo-006",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 4,
        "visualVariantCount": 4,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "linen-woven",
          "groupLabel": "Linen & Woven",
          "groupOrder": 2,
          "navigationState": "available"
        }
      },
      {
        "id": "NDR-V2-ZB-SB-003",
        "label": "Palm Cove Zebra Semi-Blackout",
        "fabricTypes": [
          "semi-blackout"
        ],
        "representativeMediaKey": "fabric-zb-sb-003-c01",
        "roomMediaKey": "room-zb-sb-003",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 5,
        "visualVariantCount": 5,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "linen-woven",
          "groupLabel": "Linen & Woven",
          "groupOrder": 2,
          "navigationState": "available"
        }
      },
      {
        "id": "NDR-V2-ZB-SB-004",
        "label": "Harbor Linen Zebra Semi-Blackout",
        "fabricTypes": [
          "semi-blackout"
        ],
        "representativeMediaKey": "fabric-zb-sb-004-c01",
        "roomMediaKey": "room-zb-sb-004",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 5,
        "visualVariantCount": 5,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "linen-woven",
          "groupLabel": "Linen & Woven",
          "groupOrder": 2,
          "navigationState": "available"
        }
      },
      {
        "id": "NDR-V2-ZB-UH-001",
        "label": "Marina Zebra Classification Hold",
        "fabricTypes": [
          "classification-pending"
        ],
        "representativeMediaKey": "fabric-zb-uh-001-c01",
        "roomMediaKey": "room-zb-uh-001",
        "buildEligible": true,
        "configurationEligible": false,
        "launchEligible": false,
        "evidenceState": "classification-hold",
        "documentedVariantCount": 6,
        "visualVariantCount": 6,
        "navigation": {
          "axisId": "light-control",
          "axisLabel": "Light control pending",
          "groupId": null,
          "groupLabel": null,
          "groupOrder": null,
          "navigationState": "held"
        }
      },
      {
        "id": "NDR-V2-ZB-BO-007",
        "label": "Hillsboro Silky Zebra Blackout",
        "fabricTypes": [
          "blackout"
        ],
        "representativeMediaKey": "fabric-zb-bo-007-c01",
        "roomMediaKey": "room-zb-bo-007",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 4,
        "visualVariantCount": 4,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "linear-silky",
          "groupLabel": "Linear & Silky",
          "groupOrder": 3,
          "navigationState": "available"
        }
      },
      {
        "id": "NDR-V2-ZB-BO-008",
        "label": "Hillsboro Deep-Tone Zebra Blackout",
        "fabricTypes": [
          "blackout"
        ],
        "representativeMediaKey": "fabric-zb-bo-008-c01",
        "roomMediaKey": "room-zb-bo-008",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 4,
        "visualVariantCount": 4,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "linear-silky",
          "groupLabel": "Linear & Silky",
          "groupOrder": 3,
          "navigationState": "available"
        }
      },
      {
        "id": "NDR-V2-ZB-BO-009",
        "label": "Key Biscayne Zebra Blackout",
        "fabricTypes": [
          "blackout"
        ],
        "representativeMediaKey": "fabric-zb-bo-009-c01",
        "roomMediaKey": "room-zb-bo-009",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 4,
        "visualVariantCount": 4,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "classic-clean",
          "groupLabel": "Classic & Clean",
          "groupOrder": 1,
          "navigationState": "available"
        }
      },
      {
        "id": "NDR-V2-ZB-SB-005",
        "label": "Bluewater Zebra Semi-Blackout",
        "fabricTypes": [
          "semi-blackout"
        ],
        "representativeMediaKey": "fabric-zb-sb-005-c01",
        "roomMediaKey": "room-zb-sb-005",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 4,
        "visualVariantCount": 4,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "classic-clean",
          "groupLabel": "Classic & Clean",
          "groupOrder": 1,
          "navigationState": "available"
        }
      },
      {
        "id": "NDR-V2-ZB-SB-006",
        "label": "Lagoon Zebra Semi-Blackout",
        "fabricTypes": [
          "semi-blackout"
        ],
        "representativeMediaKey": "fabric-zb-sb-006-c01",
        "roomMediaKey": "room-zb-sb-006",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 4,
        "visualVariantCount": 4,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "classic-clean",
          "groupLabel": "Classic & Clean",
          "groupOrder": 1,
          "navigationState": "available"
        }
      },
      {
        "id": "NDR-V2-ZB-SB-007",
        "label": "Lagoon Deep-Tone Zebra Semi-Blackout",
        "fabricTypes": [
          "semi-blackout"
        ],
        "representativeMediaKey": "fabric-zb-sb-007-c01",
        "roomMediaKey": "room-zb-sb-007",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 3,
        "visualVariantCount": 3,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "classic-clean",
          "groupLabel": "Classic & Clean",
          "groupOrder": 1,
          "navigationState": "available"
        }
      },
      {
        "id": "NDR-V2-ZB-SB-008",
        "label": "Harbor Zebra Semi-Blackout",
        "fabricTypes": [
          "semi-blackout"
        ],
        "representativeMediaKey": "fabric-zb-sb-008-c01",
        "roomMediaKey": "room-zb-sb-008",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 5,
        "visualVariantCount": 5,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "linen-woven",
          "groupLabel": "Linen & Woven",
          "groupOrder": 2,
          "navigationState": "available"
        }
      },
      {
        "id": "NDR-V2-ZB-SB-009",
        "label": "Harbor Colorweave Zebra Semi-Blackout",
        "fabricTypes": [
          "semi-blackout"
        ],
        "representativeMediaKey": "fabric-zb-sb-009-c01",
        "roomMediaKey": "room-zb-sb-009",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 4,
        "visualVariantCount": 4,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "linen-woven",
          "groupLabel": "Linen & Woven",
          "groupOrder": 2,
          "navigationState": "available"
        }
      },
      {
        "id": "NDR-V2-ZB-SB-010",
        "label": "Garden Embroidered Zebra Semi-Blackout",
        "fabricTypes": [
          "semi-blackout"
        ],
        "representativeMediaKey": "fabric-zb-sb-010-c01",
        "roomMediaKey": "room-zb-sb-010",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 3,
        "visualVariantCount": 3,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "patterned-embroidered",
          "groupLabel": "Patterned & Embroidered",
          "groupOrder": 4,
          "navigationState": "available"
        }
      },
      {
        "id": "NDR-V2-ZB-SB-011",
        "label": "Botanical Embroidered Zebra Semi-Blackout",
        "fabricTypes": [
          "semi-blackout"
        ],
        "representativeMediaKey": "fabric-zb-sb-011-c01",
        "roomMediaKey": "room-zb-sb-011",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 4,
        "visualVariantCount": 4,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "patterned-embroidered",
          "groupLabel": "Patterned & Embroidered",
          "groupOrder": 4,
          "navigationState": "available"
        }
      },
      {
        "id": "NDR-V2-ZB-SB-012",
        "label": "Regatta Basketweave Zebra Semi-Blackout",
        "fabricTypes": [
          "semi-blackout"
        ],
        "representativeMediaKey": "fabric-zb-sb-012-c01",
        "roomMediaKey": "room-zb-sb-012",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 4,
        "visualVariantCount": 4,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "linen-woven",
          "groupLabel": "Linen & Woven",
          "groupOrder": 2,
          "navigationState": "available"
        }
      },
      {
        "id": "NDR-V2-ZB-SB-013",
        "label": "Regatta Deep-Tone Zebra Semi-Blackout",
        "fabricTypes": [
          "semi-blackout"
        ],
        "representativeMediaKey": "fabric-zb-sb-013-c01",
        "roomMediaKey": "room-zb-sb-013",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 4,
        "visualVariantCount": 4,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "linen-woven",
          "groupLabel": "Linen & Woven",
          "groupOrder": 2,
          "navigationState": "available"
        }
      },
      {
        "id": "NDR-V2-ZB-SB-001",
        "label": "Caspian Basketweave Semi-Blackout",
        "fabricTypes": [
          "semi-blackout"
        ],
        "representativeMediaKey": "fabric-zb-sb-001-c01",
        "roomMediaKey": "room-zb-sb-001",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 5,
        "visualVariantCount": 5,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "linen-woven",
          "groupLabel": "Linen & Woven",
          "groupOrder": 2,
          "navigationState": "available"
        }
      },
      {
        "id": "NDR-V2-ZB-SB-014",
        "label": "Caspian Linear Zebra Semi-Blackout",
        "fabricTypes": [
          "semi-blackout"
        ],
        "representativeMediaKey": "fabric-zb-sb-014-c01",
        "roomMediaKey": "room-zb-sb-014",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 6,
        "visualVariantCount": 6,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "linear-dimensional",
          "groupLabel": "Linear & Dimensional",
          "groupOrder": 3,
          "navigationState": "available"
        }
      },
      {
        "id": "NDR-V2-ZB-UH-002",
        "label": "Caspian Jacquard Classification Hold",
        "fabricTypes": [
          "classification-pending"
        ],
        "representativeMediaKey": "fabric-zb-uh-002-c01",
        "roomMediaKey": "room-zb-uh-002",
        "buildEligible": true,
        "configurationEligible": false,
        "launchEligible": false,
        "evidenceState": "classification-hold",
        "documentedVariantCount": 4,
        "visualVariantCount": 4,
        "navigation": {
          "axisId": "light-control",
          "axisLabel": "Light control pending",
          "groupId": null,
          "groupLabel": null,
          "groupOrder": null,
          "navigationState": "held"
        }
      },
      {
        "id": "NDR-V2-ZB-BO-010",
        "label": "Flagler Colorweave Zebra Blackout",
        "fabricTypes": [
          "blackout"
        ],
        "representativeMediaKey": "fabric-zb-bo-010-c01",
        "roomMediaKey": "room-zb-bo-010",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 7,
        "visualVariantCount": 7,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "classic-clean",
          "groupLabel": "Classic & Clean",
          "groupOrder": 1,
          "navigationState": "available"
        }
      },
      {
        "id": "NDR-V2-ZB-BO-011",
        "label": "Waterway Woven Zebra Blackout",
        "fabricTypes": [
          "blackout"
        ],
        "representativeMediaKey": "fabric-zb-bo-011-c01",
        "roomMediaKey": "room-zb-bo-011",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 5,
        "visualVariantCount": 5,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "linen-woven",
          "groupLabel": "Linen & Woven",
          "groupOrder": 2,
          "navigationState": "available"
        }
      },
      {
        "id": "NDR-V2-ZB-BO-012",
        "label": "Ocean Park Zebra Blackout",
        "fabricTypes": [
          "blackout"
        ],
        "representativeMediaKey": "fabric-zb-bo-012-c01",
        "roomMediaKey": "room-zb-bo-012",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 5,
        "visualVariantCount": 5,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "classic-clean",
          "groupLabel": "Classic & Clean",
          "groupOrder": 1,
          "navigationState": "available"
        }
      },
      {
        "id": "NDR-V2-ZB-BO-013",
        "label": "Ocean Park Deep-Tone Zebra Blackout",
        "fabricTypes": [
          "blackout"
        ],
        "representativeMediaKey": "fabric-zb-bo-013-c01",
        "roomMediaKey": "room-zb-bo-013",
        "buildEligible": true,
        "configurationEligible": false,
        "launchEligible": false,
        "evidenceState": "source-evidence-hold",
        "documentedVariantCount": 6,
        "visualVariantCount": 3,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "classic-clean",
          "groupLabel": "Classic & Clean",
          "groupOrder": 1,
          "navigationState": "held"
        }
      },
      {
        "id": "NDR-V2-ZB-SB-015",
        "label": "Delray Dimensional Zebra Semi-Blackout",
        "fabricTypes": [
          "semi-blackout"
        ],
        "representativeMediaKey": "fabric-zb-sb-015-c01",
        "roomMediaKey": "room-zb-sb-015",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 4,
        "visualVariantCount": 4,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "linear-dimensional",
          "groupLabel": "Linear & Dimensional",
          "groupOrder": 3,
          "navigationState": "available"
        }
      },
      {
        "id": "NDR-V2-ZB-UH-003",
        "label": "Pompano Zebra Classification Hold",
        "fabricTypes": [
          "classification-pending"
        ],
        "representativeMediaKey": "fabric-zb-uh-003-c01",
        "roomMediaKey": "room-zb-uh-003",
        "buildEligible": true,
        "configurationEligible": false,
        "launchEligible": false,
        "evidenceState": "classification-hold",
        "documentedVariantCount": 6,
        "visualVariantCount": 6,
        "navigation": {
          "axisId": "light-control",
          "axisLabel": "Light control pending",
          "groupId": null,
          "groupLabel": null,
          "groupOrder": null,
          "navigationState": "held"
        }
      },
      {
        "id": "NDR-V2-ZB-SB-016",
        "label": "Boca Color Zebra Semi-Blackout",
        "fabricTypes": [
          "semi-blackout"
        ],
        "representativeMediaKey": "fabric-zb-sb-016-c01",
        "roomMediaKey": "room-zb-sb-016",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 6,
        "visualVariantCount": 6,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "classic-clean",
          "groupLabel": "Classic & Clean",
          "groupOrder": 1,
          "navigationState": "available"
        }
      },
      {
        "id": "NDR-V2-ZB-SB-017",
        "label": "Boca Natural Zebra Semi-Blackout",
        "fabricTypes": [
          "semi-blackout"
        ],
        "representativeMediaKey": "fabric-zb-sb-017-c01",
        "roomMediaKey": "room-zb-sb-017",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 6,
        "visualVariantCount": 6,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "classic-clean",
          "groupLabel": "Classic & Clean",
          "groupOrder": 1,
          "navigationState": "available"
        }
      },
      {
        "id": "NDR-V2-ZB-SB-018",
        "label": "Boca Coastal Zebra Semi-Blackout",
        "fabricTypes": [
          "semi-blackout"
        ],
        "representativeMediaKey": "fabric-zb-sb-018-c01",
        "roomMediaKey": "room-zb-sb-018",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 6,
        "visualVariantCount": 6,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "classic-clean",
          "groupLabel": "Classic & Clean",
          "groupOrder": 1,
          "navigationState": "available"
        }
      },
      {
        "id": "NDR-V2-ZB-SB-019",
        "label": "Boca Modern Zebra Semi-Blackout",
        "fabricTypes": [
          "semi-blackout"
        ],
        "representativeMediaKey": "fabric-zb-sb-019-c01",
        "roomMediaKey": "room-zb-sb-019",
        "buildEligible": true,
        "configurationEligible": true,
        "launchEligible": false,
        "evidenceState": "catalog-mapped",
        "documentedVariantCount": 6,
        "visualVariantCount": 6,
        "navigation": {
          "axisId": "look",
          "axisLabel": "Shop by look",
          "groupId": "classic-clean",
          "groupLabel": "Classic & Clean",
          "groupOrder": 1,
          "navigationState": "available"
        }
      }
    ],
    "variants": [
      {
        "id": "NDR-V2-ZB-BO-002-C01",
        "familyId": "NDR-V2-ZB-BO-002",
        "label": "Cloud White",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-002-c01",
        "weaveDetailMediaKey": "weave-zb-bo-002-c01"
      },
      {
        "id": "NDR-V2-ZB-BO-002-C02",
        "familyId": "NDR-V2-ZB-BO-002",
        "label": "Soft White",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-002-c02",
        "weaveDetailMediaKey": "weave-zb-bo-002-c02"
      },
      {
        "id": "NDR-V2-ZB-BO-002-C03",
        "familyId": "NDR-V2-ZB-BO-002",
        "label": "Ivory",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-002-c03",
        "weaveDetailMediaKey": "weave-zb-bo-002-c03"
      },
      {
        "id": "NDR-V2-ZB-BO-002-C04",
        "familyId": "NDR-V2-ZB-BO-002",
        "label": "Slate",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-002-c04",
        "weaveDetailMediaKey": "weave-zb-bo-002-c04"
      },
      {
        "id": "NDR-V2-ZB-BO-002-C05",
        "familyId": "NDR-V2-ZB-BO-002",
        "label": "Onyx",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-002-c05",
        "weaveDetailMediaKey": "weave-zb-bo-002-c05"
      },
      {
        "id": "NDR-V2-ZB-BO-003-C01",
        "familyId": "NDR-V2-ZB-BO-003",
        "label": "Cloud White",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-003-c01",
        "weaveDetailMediaKey": "weave-zb-bo-003-c01"
      },
      {
        "id": "NDR-V2-ZB-BO-003-C02",
        "familyId": "NDR-V2-ZB-BO-003",
        "label": "Pearl",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-003-c02",
        "weaveDetailMediaKey": "weave-zb-bo-003-c02"
      },
      {
        "id": "NDR-V2-ZB-BO-003-C03",
        "familyId": "NDR-V2-ZB-BO-003",
        "label": "Linen",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-003-c03",
        "weaveDetailMediaKey": "weave-zb-bo-003-c03"
      },
      {
        "id": "NDR-V2-ZB-BO-003-C04",
        "familyId": "NDR-V2-ZB-BO-003",
        "label": "Graphite",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-003-c04",
        "weaveDetailMediaKey": "weave-zb-bo-003-c04"
      },
      {
        "id": "NDR-V2-ZB-BO-003-C05",
        "familyId": "NDR-V2-ZB-BO-003",
        "label": "Pewter",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-003-c05",
        "weaveDetailMediaKey": "weave-zb-bo-003-c05"
      },
      {
        "id": "NDR-V2-ZB-BO-003-C06",
        "familyId": "NDR-V2-ZB-BO-003",
        "label": "Onyx",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-003-c06",
        "weaveDetailMediaKey": "weave-zb-bo-003-c06"
      },
      {
        "id": "NDR-V2-ZB-BO-004-C01",
        "familyId": "NDR-V2-ZB-BO-004",
        "label": "Silver",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-004-c01",
        "weaveDetailMediaKey": "weave-zb-bo-004-c01"
      },
      {
        "id": "NDR-V2-ZB-BO-004-C02",
        "familyId": "NDR-V2-ZB-BO-004",
        "label": "Slate",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-004-c02",
        "weaveDetailMediaKey": "weave-zb-bo-004-c02"
      },
      {
        "id": "NDR-V2-ZB-BO-004-C03",
        "familyId": "NDR-V2-ZB-BO-004",
        "label": "Linen",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-004-c03",
        "weaveDetailMediaKey": "weave-zb-bo-004-c03"
      },
      {
        "id": "NDR-V2-ZB-BO-004-C04",
        "familyId": "NDR-V2-ZB-BO-004",
        "label": "Olive",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-004-c04",
        "weaveDetailMediaKey": "weave-zb-bo-004-c04"
      },
      {
        "id": "NDR-V2-ZB-BO-004-C05",
        "familyId": "NDR-V2-ZB-BO-004",
        "label": "Pewter",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-004-c05",
        "weaveDetailMediaKey": "weave-zb-bo-004-c05"
      },
      {
        "id": "NDR-V2-ZB-BO-004-C06",
        "familyId": "NDR-V2-ZB-BO-004",
        "label": "Espresso",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-004-c06",
        "weaveDetailMediaKey": "weave-zb-bo-004-c06"
      },
      {
        "id": "NDR-V2-ZB-BO-004-C07",
        "familyId": "NDR-V2-ZB-BO-004",
        "label": "Onyx",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-004-c07",
        "weaveDetailMediaKey": "weave-zb-bo-004-c07"
      },
      {
        "id": "NDR-V2-ZB-BO-001-C01",
        "familyId": "NDR-V2-ZB-BO-001",
        "label": "Cloud White",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-001-c01",
        "weaveDetailMediaKey": "weave-zb-bo-001-c01"
      },
      {
        "id": "NDR-V2-ZB-BO-001-C02",
        "familyId": "NDR-V2-ZB-BO-001",
        "label": "Warm Sand",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-001-c02",
        "weaveDetailMediaKey": "weave-zb-bo-001-c02"
      },
      {
        "id": "NDR-V2-ZB-BO-001-C03",
        "familyId": "NDR-V2-ZB-BO-001",
        "label": "Driftwood",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-001-c03",
        "weaveDetailMediaKey": "weave-zb-bo-001-c03"
      },
      {
        "id": "NDR-V2-ZB-BO-001-C04",
        "familyId": "NDR-V2-ZB-BO-001",
        "label": "Silver Gray",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-001-c04",
        "weaveDetailMediaKey": "weave-zb-bo-001-c04"
      },
      {
        "id": "NDR-V2-ZB-BO-001-C05",
        "familyId": "NDR-V2-ZB-BO-001",
        "label": "Slate",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-001-c05",
        "weaveDetailMediaKey": "weave-zb-bo-001-c05"
      },
      {
        "id": "NDR-V2-ZB-BO-001-C06",
        "familyId": "NDR-V2-ZB-BO-001",
        "label": "Espresso",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-001-c06",
        "weaveDetailMediaKey": "weave-zb-bo-001-c06"
      },
      {
        "id": "NDR-V2-ZB-BO-001-C07",
        "familyId": "NDR-V2-ZB-BO-001",
        "label": "Onyx",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-001-c07",
        "weaveDetailMediaKey": "weave-zb-bo-001-c07"
      },
      {
        "id": "NDR-V2-ZB-SB-002-C01",
        "familyId": "NDR-V2-ZB-SB-002",
        "label": "Cloud White",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-002-c01",
        "weaveDetailMediaKey": "weave-zb-sb-002-c01"
      },
      {
        "id": "NDR-V2-ZB-SB-002-C02",
        "familyId": "NDR-V2-ZB-SB-002",
        "label": "Soft White",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-002-c02",
        "weaveDetailMediaKey": "weave-zb-sb-002-c02"
      },
      {
        "id": "NDR-V2-ZB-SB-002-C03",
        "familyId": "NDR-V2-ZB-SB-002",
        "label": "Cream",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-002-c03",
        "weaveDetailMediaKey": "weave-zb-sb-002-c03"
      },
      {
        "id": "NDR-V2-ZB-SB-002-C04",
        "familyId": "NDR-V2-ZB-SB-002",
        "label": "Silver",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-002-c04",
        "weaveDetailMediaKey": "weave-zb-sb-002-c04"
      },
      {
        "id": "NDR-V2-ZB-SB-002-C05",
        "familyId": "NDR-V2-ZB-SB-002",
        "label": "Gray",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-002-c05",
        "weaveDetailMediaKey": "weave-zb-sb-002-c05"
      },
      {
        "id": "NDR-V2-ZB-SB-002-C06",
        "familyId": "NDR-V2-ZB-SB-002",
        "label": "Espresso",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-002-c06",
        "weaveDetailMediaKey": "weave-zb-sb-002-c06"
      },
      {
        "id": "NDR-V2-ZB-SB-002-C07",
        "familyId": "NDR-V2-ZB-SB-002",
        "label": "Onyx",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-002-c07",
        "weaveDetailMediaKey": "weave-zb-sb-002-c07"
      },
      {
        "id": "NDR-V2-ZB-BO-005-C01",
        "familyId": "NDR-V2-ZB-BO-005",
        "label": "Cloud White",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-005-c01",
        "weaveDetailMediaKey": "weave-zb-bo-005-c01"
      },
      {
        "id": "NDR-V2-ZB-BO-005-C02",
        "familyId": "NDR-V2-ZB-BO-005",
        "label": "Oatmeal",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-005-c02",
        "weaveDetailMediaKey": "weave-zb-bo-005-c02"
      },
      {
        "id": "NDR-V2-ZB-BO-005-C03",
        "familyId": "NDR-V2-ZB-BO-005",
        "label": "Silver",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-005-c03",
        "weaveDetailMediaKey": "weave-zb-bo-005-c03"
      },
      {
        "id": "NDR-V2-ZB-BO-005-C04",
        "familyId": "NDR-V2-ZB-BO-005",
        "label": "Espresso",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-005-c04",
        "weaveDetailMediaKey": "weave-zb-bo-005-c04"
      },
      {
        "id": "NDR-V2-ZB-BO-005-C05",
        "familyId": "NDR-V2-ZB-BO-005",
        "label": "Onyx",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-005-c05",
        "weaveDetailMediaKey": "weave-zb-bo-005-c05"
      },
      {
        "id": "NDR-V2-ZB-BO-006-C01",
        "familyId": "NDR-V2-ZB-BO-006",
        "label": "Silver",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-006-c01",
        "weaveDetailMediaKey": "weave-zb-bo-006-c01"
      },
      {
        "id": "NDR-V2-ZB-BO-006-C02",
        "familyId": "NDR-V2-ZB-BO-006",
        "label": "Olive",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-006-c02",
        "weaveDetailMediaKey": "weave-zb-bo-006-c02"
      },
      {
        "id": "NDR-V2-ZB-BO-006-C03",
        "familyId": "NDR-V2-ZB-BO-006",
        "label": "Graphite",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-006-c03",
        "weaveDetailMediaKey": "weave-zb-bo-006-c03"
      },
      {
        "id": "NDR-V2-ZB-BO-006-C04",
        "familyId": "NDR-V2-ZB-BO-006",
        "label": "Onyx",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-006-c04",
        "weaveDetailMediaKey": "weave-zb-bo-006-c04"
      },
      {
        "id": "NDR-V2-ZB-SB-003-C01",
        "familyId": "NDR-V2-ZB-SB-003",
        "label": "Cloud White",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-003-c01",
        "weaveDetailMediaKey": "weave-zb-sb-003-c01"
      },
      {
        "id": "NDR-V2-ZB-SB-003-C02",
        "familyId": "NDR-V2-ZB-SB-003",
        "label": "Oatmeal",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-003-c02",
        "weaveDetailMediaKey": "weave-zb-sb-003-c02"
      },
      {
        "id": "NDR-V2-ZB-SB-003-C03",
        "familyId": "NDR-V2-ZB-SB-003",
        "label": "Silver",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-003-c03",
        "weaveDetailMediaKey": "weave-zb-sb-003-c03"
      },
      {
        "id": "NDR-V2-ZB-SB-003-C04",
        "familyId": "NDR-V2-ZB-SB-003",
        "label": "Rose",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-003-c04",
        "weaveDetailMediaKey": "weave-zb-sb-003-c04"
      },
      {
        "id": "NDR-V2-ZB-SB-003-C05",
        "familyId": "NDR-V2-ZB-SB-003",
        "label": "Onyx",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-003-c05",
        "weaveDetailMediaKey": "weave-zb-sb-003-c05"
      },
      {
        "id": "NDR-V2-ZB-SB-004-C01",
        "familyId": "NDR-V2-ZB-SB-004",
        "label": "Cloud White",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-004-c01",
        "weaveDetailMediaKey": "weave-zb-sb-004-c01"
      },
      {
        "id": "NDR-V2-ZB-SB-004-C02",
        "familyId": "NDR-V2-ZB-SB-004",
        "label": "Pearl",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-004-c02",
        "weaveDetailMediaKey": "weave-zb-sb-004-c02"
      },
      {
        "id": "NDR-V2-ZB-SB-004-C03",
        "familyId": "NDR-V2-ZB-SB-004",
        "label": "Silver",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-004-c03",
        "weaveDetailMediaKey": "weave-zb-sb-004-c03"
      },
      {
        "id": "NDR-V2-ZB-SB-004-C04",
        "familyId": "NDR-V2-ZB-SB-004",
        "label": "Rosewood",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-004-c04",
        "weaveDetailMediaKey": "weave-zb-sb-004-c04"
      },
      {
        "id": "NDR-V2-ZB-SB-004-C05",
        "familyId": "NDR-V2-ZB-SB-004",
        "label": "Slate",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-004-c05",
        "weaveDetailMediaKey": "weave-zb-sb-004-c05"
      },
      {
        "id": "NDR-V2-ZB-UH-001-C01",
        "familyId": "NDR-V2-ZB-UH-001",
        "label": "Linen",
        "fabricType": "classification-pending",
        "selectorMediaKey": "fabric-zb-uh-001-c01"
      },
      {
        "id": "NDR-V2-ZB-UH-001-C02",
        "familyId": "NDR-V2-ZB-UH-001",
        "label": "Oatmeal",
        "fabricType": "classification-pending",
        "selectorMediaKey": "fabric-zb-uh-001-c02"
      },
      {
        "id": "NDR-V2-ZB-UH-001-C03",
        "familyId": "NDR-V2-ZB-UH-001",
        "label": "Taupe",
        "fabricType": "classification-pending",
        "selectorMediaKey": "fabric-zb-uh-001-c03"
      },
      {
        "id": "NDR-V2-ZB-UH-001-C04",
        "familyId": "NDR-V2-ZB-UH-001",
        "label": "Silver",
        "fabricType": "classification-pending",
        "selectorMediaKey": "fabric-zb-uh-001-c04"
      },
      {
        "id": "NDR-V2-ZB-UH-001-C05",
        "familyId": "NDR-V2-ZB-UH-001",
        "label": "Olive",
        "fabricType": "classification-pending",
        "selectorMediaKey": "fabric-zb-uh-001-c05"
      },
      {
        "id": "NDR-V2-ZB-UH-001-C06",
        "familyId": "NDR-V2-ZB-UH-001",
        "label": "Graphite",
        "fabricType": "classification-pending",
        "selectorMediaKey": "fabric-zb-uh-001-c06"
      },
      {
        "id": "NDR-V2-ZB-BO-007-C01",
        "familyId": "NDR-V2-ZB-BO-007",
        "label": "Oatmeal",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-007-c01",
        "weaveDetailMediaKey": "weave-zb-bo-007-c01"
      },
      {
        "id": "NDR-V2-ZB-BO-007-C02",
        "familyId": "NDR-V2-ZB-BO-007",
        "label": "Taupe",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-007-c02",
        "weaveDetailMediaKey": "weave-zb-bo-007-c02"
      },
      {
        "id": "NDR-V2-ZB-BO-007-C03",
        "familyId": "NDR-V2-ZB-BO-007",
        "label": "Linen",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-007-c03",
        "weaveDetailMediaKey": "weave-zb-bo-007-c03"
      },
      {
        "id": "NDR-V2-ZB-BO-007-C04",
        "familyId": "NDR-V2-ZB-BO-007",
        "label": "Silver",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-007-c04",
        "weaveDetailMediaKey": "weave-zb-bo-007-c04"
      },
      {
        "id": "NDR-V2-ZB-BO-008-C01",
        "familyId": "NDR-V2-ZB-BO-008",
        "label": "Graphite",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-008-c01",
        "weaveDetailMediaKey": "weave-zb-bo-008-c01"
      },
      {
        "id": "NDR-V2-ZB-BO-008-C02",
        "familyId": "NDR-V2-ZB-BO-008",
        "label": "Driftwood",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-008-c02",
        "weaveDetailMediaKey": "weave-zb-bo-008-c02"
      },
      {
        "id": "NDR-V2-ZB-BO-008-C03",
        "familyId": "NDR-V2-ZB-BO-008",
        "label": "Espresso",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-008-c03",
        "weaveDetailMediaKey": "weave-zb-bo-008-c03"
      },
      {
        "id": "NDR-V2-ZB-BO-008-C04",
        "familyId": "NDR-V2-ZB-BO-008",
        "label": "Onyx",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-008-c04",
        "weaveDetailMediaKey": "weave-zb-bo-008-c04"
      },
      {
        "id": "NDR-V2-ZB-BO-009-C01",
        "familyId": "NDR-V2-ZB-BO-009",
        "label": "Pearl",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-009-c01",
        "weaveDetailMediaKey": "weave-zb-bo-009-c01"
      },
      {
        "id": "NDR-V2-ZB-BO-009-C02",
        "familyId": "NDR-V2-ZB-BO-009",
        "label": "Silver",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-009-c02",
        "weaveDetailMediaKey": "weave-zb-bo-009-c02"
      },
      {
        "id": "NDR-V2-ZB-BO-009-C03",
        "familyId": "NDR-V2-ZB-BO-009",
        "label": "Linen",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-009-c03",
        "weaveDetailMediaKey": "weave-zb-bo-009-c03"
      },
      {
        "id": "NDR-V2-ZB-BO-009-C04",
        "familyId": "NDR-V2-ZB-BO-009",
        "label": "Blue Gray",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-009-c04",
        "weaveDetailMediaKey": "weave-zb-bo-009-c04"
      },
      {
        "id": "NDR-V2-ZB-SB-005-C01",
        "familyId": "NDR-V2-ZB-SB-005",
        "label": "Cloud White",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-005-c01",
        "weaveDetailMediaKey": "weave-zb-sb-005-c01"
      },
      {
        "id": "NDR-V2-ZB-SB-005-C02",
        "familyId": "NDR-V2-ZB-SB-005",
        "label": "Silver",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-005-c02",
        "weaveDetailMediaKey": "weave-zb-sb-005-c02"
      },
      {
        "id": "NDR-V2-ZB-SB-005-C03",
        "familyId": "NDR-V2-ZB-SB-005",
        "label": "Graphite",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-005-c03",
        "weaveDetailMediaKey": "weave-zb-sb-005-c03"
      },
      {
        "id": "NDR-V2-ZB-SB-005-C04",
        "familyId": "NDR-V2-ZB-SB-005",
        "label": "Espresso",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-005-c04",
        "weaveDetailMediaKey": "weave-zb-sb-005-c04"
      },
      {
        "id": "NDR-V2-ZB-SB-006-C01",
        "familyId": "NDR-V2-ZB-SB-006",
        "label": "Cloud White",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-006-c01",
        "weaveDetailMediaKey": "weave-zb-sb-006-c01"
      },
      {
        "id": "NDR-V2-ZB-SB-006-C02",
        "familyId": "NDR-V2-ZB-SB-006",
        "label": "Linen",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-006-c02",
        "weaveDetailMediaKey": "weave-zb-sb-006-c02"
      },
      {
        "id": "NDR-V2-ZB-SB-006-C03",
        "familyId": "NDR-V2-ZB-SB-006",
        "label": "Sandbar",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-006-c03",
        "weaveDetailMediaKey": "weave-zb-sb-006-c03"
      },
      {
        "id": "NDR-V2-ZB-SB-006-C04",
        "familyId": "NDR-V2-ZB-SB-006",
        "label": "Sky",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-006-c04",
        "weaveDetailMediaKey": "weave-zb-sb-006-c04"
      },
      {
        "id": "NDR-V2-ZB-SB-007-C01",
        "familyId": "NDR-V2-ZB-SB-007",
        "label": "Silver",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-007-c01",
        "weaveDetailMediaKey": "weave-zb-sb-007-c01"
      },
      {
        "id": "NDR-V2-ZB-SB-007-C02",
        "familyId": "NDR-V2-ZB-SB-007",
        "label": "Slate",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-007-c02",
        "weaveDetailMediaKey": "weave-zb-sb-007-c02"
      },
      {
        "id": "NDR-V2-ZB-SB-007-C03",
        "familyId": "NDR-V2-ZB-SB-007",
        "label": "Espresso",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-007-c03",
        "weaveDetailMediaKey": "weave-zb-sb-007-c03"
      },
      {
        "id": "NDR-V2-ZB-SB-008-C01",
        "familyId": "NDR-V2-ZB-SB-008",
        "label": "Cloud White",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-008-c01",
        "weaveDetailMediaKey": "weave-zb-sb-008-c01"
      },
      {
        "id": "NDR-V2-ZB-SB-008-C02",
        "familyId": "NDR-V2-ZB-SB-008",
        "label": "Linen",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-008-c02",
        "weaveDetailMediaKey": "weave-zb-sb-008-c02"
      },
      {
        "id": "NDR-V2-ZB-SB-008-C03",
        "familyId": "NDR-V2-ZB-SB-008",
        "label": "Oatmeal",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-008-c03",
        "weaveDetailMediaKey": "weave-zb-sb-008-c03"
      },
      {
        "id": "NDR-V2-ZB-SB-008-C04",
        "familyId": "NDR-V2-ZB-SB-008",
        "label": "Silver",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-008-c04",
        "weaveDetailMediaKey": "weave-zb-sb-008-c04"
      },
      {
        "id": "NDR-V2-ZB-SB-008-C05",
        "familyId": "NDR-V2-ZB-SB-008",
        "label": "Olive",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-008-c05",
        "weaveDetailMediaKey": "weave-zb-sb-008-c05"
      },
      {
        "id": "NDR-V2-ZB-SB-009-C01",
        "familyId": "NDR-V2-ZB-SB-009",
        "label": "Wine",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-009-c01",
        "weaveDetailMediaKey": "weave-zb-sb-009-c01"
      },
      {
        "id": "NDR-V2-ZB-SB-009-C02",
        "familyId": "NDR-V2-ZB-SB-009",
        "label": "Teal",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-009-c02",
        "weaveDetailMediaKey": "weave-zb-sb-009-c02"
      },
      {
        "id": "NDR-V2-ZB-SB-009-C03",
        "familyId": "NDR-V2-ZB-SB-009",
        "label": "Blue Gray",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-009-c03",
        "weaveDetailMediaKey": "weave-zb-sb-009-c03"
      },
      {
        "id": "NDR-V2-ZB-SB-009-C04",
        "familyId": "NDR-V2-ZB-SB-009",
        "label": "Onyx",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-009-c04",
        "weaveDetailMediaKey": "weave-zb-sb-009-c04"
      },
      {
        "id": "NDR-V2-ZB-SB-010-C01",
        "familyId": "NDR-V2-ZB-SB-010",
        "label": "Ivory Blossom",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-010-c01",
        "weaveDetailMediaKey": "weave-zb-sb-010-c01"
      },
      {
        "id": "NDR-V2-ZB-SB-010-C02",
        "familyId": "NDR-V2-ZB-SB-010",
        "label": "Oatmeal Blossom",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-010-c02",
        "weaveDetailMediaKey": "weave-zb-sb-010-c02"
      },
      {
        "id": "NDR-V2-ZB-SB-010-C03",
        "familyId": "NDR-V2-ZB-SB-010",
        "label": "Silver Blossom",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-010-c03",
        "weaveDetailMediaKey": "weave-zb-sb-010-c03"
      },
      {
        "id": "NDR-V2-ZB-SB-011-C01",
        "familyId": "NDR-V2-ZB-SB-011",
        "label": "Ivory Botanical",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-011-c01",
        "weaveDetailMediaKey": "weave-zb-sb-011-c01"
      },
      {
        "id": "NDR-V2-ZB-SB-011-C02",
        "familyId": "NDR-V2-ZB-SB-011",
        "label": "Silver Botanical",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-011-c02",
        "weaveDetailMediaKey": "weave-zb-sb-011-c02"
      },
      {
        "id": "NDR-V2-ZB-SB-011-C03",
        "familyId": "NDR-V2-ZB-SB-011",
        "label": "Linen Botanical",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-011-c03",
        "weaveDetailMediaKey": "weave-zb-sb-011-c03"
      },
      {
        "id": "NDR-V2-ZB-SB-011-C04",
        "familyId": "NDR-V2-ZB-SB-011",
        "label": "Pearl Botanical",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-011-c04",
        "weaveDetailMediaKey": "weave-zb-sb-011-c04"
      },
      {
        "id": "NDR-V2-ZB-SB-012-C01",
        "familyId": "NDR-V2-ZB-SB-012",
        "label": "Cloud White",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-012-c01",
        "weaveDetailMediaKey": "weave-zb-sb-012-c01"
      },
      {
        "id": "NDR-V2-ZB-SB-012-C02",
        "familyId": "NDR-V2-ZB-SB-012",
        "label": "Oatmeal",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-012-c02",
        "weaveDetailMediaKey": "weave-zb-sb-012-c02"
      },
      {
        "id": "NDR-V2-ZB-SB-012-C03",
        "familyId": "NDR-V2-ZB-SB-012",
        "label": "Linen",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-012-c03",
        "weaveDetailMediaKey": "weave-zb-sb-012-c03"
      },
      {
        "id": "NDR-V2-ZB-SB-012-C04",
        "familyId": "NDR-V2-ZB-SB-012",
        "label": "Silver",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-012-c04",
        "weaveDetailMediaKey": "weave-zb-sb-012-c04"
      },
      {
        "id": "NDR-V2-ZB-SB-013-C01",
        "familyId": "NDR-V2-ZB-SB-013",
        "label": "Graphite",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-013-c01",
        "weaveDetailMediaKey": "weave-zb-sb-013-c01"
      },
      {
        "id": "NDR-V2-ZB-SB-013-C02",
        "familyId": "NDR-V2-ZB-SB-013",
        "label": "Olive",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-013-c02",
        "weaveDetailMediaKey": "weave-zb-sb-013-c02"
      },
      {
        "id": "NDR-V2-ZB-SB-013-C03",
        "familyId": "NDR-V2-ZB-SB-013",
        "label": "Espresso",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-013-c03",
        "weaveDetailMediaKey": "weave-zb-sb-013-c03"
      },
      {
        "id": "NDR-V2-ZB-SB-013-C04",
        "familyId": "NDR-V2-ZB-SB-013",
        "label": "Onyx",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-013-c04",
        "weaveDetailMediaKey": "weave-zb-sb-013-c04"
      },
      {
        "id": "NDR-V2-ZB-SB-001-C01",
        "familyId": "NDR-V2-ZB-SB-001",
        "label": "Pearl White",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-001-c01",
        "weaveDetailMediaKey": "weave-zb-sb-001-c01"
      },
      {
        "id": "NDR-V2-ZB-SB-001-C02",
        "familyId": "NDR-V2-ZB-SB-001",
        "label": "Oatmeal",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-001-c02",
        "weaveDetailMediaKey": "weave-zb-sb-001-c02"
      },
      {
        "id": "NDR-V2-ZB-SB-001-C03",
        "familyId": "NDR-V2-ZB-SB-001",
        "label": "Silver",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-001-c03",
        "weaveDetailMediaKey": "weave-zb-sb-001-c03"
      },
      {
        "id": "NDR-V2-ZB-SB-001-C04",
        "familyId": "NDR-V2-ZB-SB-001",
        "label": "Umber",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-001-c04",
        "weaveDetailMediaKey": "weave-zb-sb-001-c04"
      },
      {
        "id": "NDR-V2-ZB-SB-001-C05",
        "familyId": "NDR-V2-ZB-SB-001",
        "label": "Onyx",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-001-c05",
        "weaveDetailMediaKey": "weave-zb-sb-001-c05"
      },
      {
        "id": "NDR-V2-ZB-SB-014-C01",
        "familyId": "NDR-V2-ZB-SB-014",
        "label": "Pearl",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-014-c01",
        "weaveDetailMediaKey": "weave-zb-sb-014-c01"
      },
      {
        "id": "NDR-V2-ZB-SB-014-C02",
        "familyId": "NDR-V2-ZB-SB-014",
        "label": "Linen",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-014-c02",
        "weaveDetailMediaKey": "weave-zb-sb-014-c02"
      },
      {
        "id": "NDR-V2-ZB-SB-014-C03",
        "familyId": "NDR-V2-ZB-SB-014",
        "label": "Silver",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-014-c03",
        "weaveDetailMediaKey": "weave-zb-sb-014-c03"
      },
      {
        "id": "NDR-V2-ZB-SB-014-C04",
        "familyId": "NDR-V2-ZB-SB-014",
        "label": "Blue Gray",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-014-c04",
        "weaveDetailMediaKey": "weave-zb-sb-014-c04"
      },
      {
        "id": "NDR-V2-ZB-SB-014-C05",
        "familyId": "NDR-V2-ZB-SB-014",
        "label": "Espresso",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-014-c05",
        "weaveDetailMediaKey": "weave-zb-sb-014-c05"
      },
      {
        "id": "NDR-V2-ZB-SB-014-C06",
        "familyId": "NDR-V2-ZB-SB-014",
        "label": "Onyx",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-014-c06",
        "weaveDetailMediaKey": "weave-zb-sb-014-c06"
      },
      {
        "id": "NDR-V2-ZB-UH-002-C01",
        "familyId": "NDR-V2-ZB-UH-002",
        "label": "Cloud White",
        "fabricType": "classification-pending",
        "selectorMediaKey": "fabric-zb-uh-002-c01"
      },
      {
        "id": "NDR-V2-ZB-UH-002-C02",
        "familyId": "NDR-V2-ZB-UH-002",
        "label": "Linen",
        "fabricType": "classification-pending",
        "selectorMediaKey": "fabric-zb-uh-002-c02"
      },
      {
        "id": "NDR-V2-ZB-UH-002-C03",
        "familyId": "NDR-V2-ZB-UH-002",
        "label": "Slate",
        "fabricType": "classification-pending",
        "selectorMediaKey": "fabric-zb-uh-002-c03"
      },
      {
        "id": "NDR-V2-ZB-UH-002-C04",
        "familyId": "NDR-V2-ZB-UH-002",
        "label": "Espresso",
        "fabricType": "classification-pending",
        "selectorMediaKey": "fabric-zb-uh-002-c04"
      },
      {
        "id": "NDR-V2-ZB-BO-010-C01",
        "familyId": "NDR-V2-ZB-BO-010",
        "label": "Silver",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-010-c01",
        "weaveDetailMediaKey": "weave-zb-bo-010-c01"
      },
      {
        "id": "NDR-V2-ZB-BO-010-C02",
        "familyId": "NDR-V2-ZB-BO-010",
        "label": "Oatmeal",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-010-c02",
        "weaveDetailMediaKey": "weave-zb-bo-010-c02"
      },
      {
        "id": "NDR-V2-ZB-BO-010-C03",
        "familyId": "NDR-V2-ZB-BO-010",
        "label": "Blush",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-010-c03",
        "weaveDetailMediaKey": "weave-zb-bo-010-c03"
      },
      {
        "id": "NDR-V2-ZB-BO-010-C04",
        "familyId": "NDR-V2-ZB-BO-010",
        "label": "Slate",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-010-c04",
        "weaveDetailMediaKey": "weave-zb-bo-010-c04"
      },
      {
        "id": "NDR-V2-ZB-BO-010-C05",
        "familyId": "NDR-V2-ZB-BO-010",
        "label": "Olive",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-010-c05",
        "weaveDetailMediaKey": "weave-zb-bo-010-c05"
      },
      {
        "id": "NDR-V2-ZB-BO-010-C06",
        "familyId": "NDR-V2-ZB-BO-010",
        "label": "Wine",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-010-c06",
        "weaveDetailMediaKey": "weave-zb-bo-010-c06"
      },
      {
        "id": "NDR-V2-ZB-BO-010-C07",
        "familyId": "NDR-V2-ZB-BO-010",
        "label": "Espresso",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-010-c07",
        "weaveDetailMediaKey": "weave-zb-bo-010-c07"
      },
      {
        "id": "NDR-V2-ZB-BO-011-C01",
        "familyId": "NDR-V2-ZB-BO-011",
        "label": "Silver",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-011-c01",
        "weaveDetailMediaKey": "weave-zb-bo-011-c01"
      },
      {
        "id": "NDR-V2-ZB-BO-011-C02",
        "familyId": "NDR-V2-ZB-BO-011",
        "label": "Linen",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-011-c02",
        "weaveDetailMediaKey": "weave-zb-bo-011-c02"
      },
      {
        "id": "NDR-V2-ZB-BO-011-C03",
        "familyId": "NDR-V2-ZB-BO-011",
        "label": "Graphite",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-011-c03",
        "weaveDetailMediaKey": "weave-zb-bo-011-c03"
      },
      {
        "id": "NDR-V2-ZB-BO-011-C04",
        "familyId": "NDR-V2-ZB-BO-011",
        "label": "Bronze",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-011-c04",
        "weaveDetailMediaKey": "weave-zb-bo-011-c04"
      },
      {
        "id": "NDR-V2-ZB-BO-011-C05",
        "familyId": "NDR-V2-ZB-BO-011",
        "label": "Onyx",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-011-c05",
        "weaveDetailMediaKey": "weave-zb-bo-011-c05"
      },
      {
        "id": "NDR-V2-ZB-BO-012-C01",
        "familyId": "NDR-V2-ZB-BO-012",
        "label": "Cloud White",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-012-c01",
        "weaveDetailMediaKey": "weave-zb-bo-012-c01"
      },
      {
        "id": "NDR-V2-ZB-BO-012-C02",
        "familyId": "NDR-V2-ZB-BO-012",
        "label": "Linen",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-012-c02",
        "weaveDetailMediaKey": "weave-zb-bo-012-c02"
      },
      {
        "id": "NDR-V2-ZB-BO-012-C03",
        "familyId": "NDR-V2-ZB-BO-012",
        "label": "Taupe",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-012-c03",
        "weaveDetailMediaKey": "weave-zb-bo-012-c03"
      },
      {
        "id": "NDR-V2-ZB-BO-012-C04",
        "familyId": "NDR-V2-ZB-BO-012",
        "label": "Slate",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-012-c04",
        "weaveDetailMediaKey": "weave-zb-bo-012-c04"
      },
      {
        "id": "NDR-V2-ZB-BO-012-C05",
        "familyId": "NDR-V2-ZB-BO-012",
        "label": "Gold",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-012-c05",
        "weaveDetailMediaKey": "weave-zb-bo-012-c05"
      },
      {
        "id": "NDR-V2-ZB-BO-013-C01",
        "familyId": "NDR-V2-ZB-BO-013",
        "label": "Bronze",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-013-c01"
      },
      {
        "id": "NDR-V2-ZB-BO-013-C05",
        "familyId": "NDR-V2-ZB-BO-013",
        "label": "Navy",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-013-c05"
      },
      {
        "id": "NDR-V2-ZB-BO-013-C06",
        "familyId": "NDR-V2-ZB-BO-013",
        "label": "Wine",
        "fabricType": "blackout",
        "selectorMediaKey": "fabric-zb-bo-013-c06"
      },
      {
        "id": "NDR-V2-ZB-SB-015-C01",
        "familyId": "NDR-V2-ZB-SB-015",
        "label": "Oatmeal Weave",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-015-c01",
        "weaveDetailMediaKey": "weave-zb-sb-015-c01"
      },
      {
        "id": "NDR-V2-ZB-SB-015-C02",
        "familyId": "NDR-V2-ZB-SB-015",
        "label": "Taupe Weave",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-015-c02",
        "weaveDetailMediaKey": "weave-zb-sb-015-c02"
      },
      {
        "id": "NDR-V2-ZB-SB-015-C03",
        "familyId": "NDR-V2-ZB-SB-015",
        "label": "Espresso Weave",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-015-c03",
        "weaveDetailMediaKey": "weave-zb-sb-015-c03"
      },
      {
        "id": "NDR-V2-ZB-SB-015-C04",
        "familyId": "NDR-V2-ZB-SB-015",
        "label": "Onyx Weave",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-015-c04",
        "weaveDetailMediaKey": "weave-zb-sb-015-c04"
      },
      {
        "id": "NDR-V2-ZB-UH-003-C01",
        "familyId": "NDR-V2-ZB-UH-003",
        "label": "Ivory",
        "fabricType": "classification-pending",
        "selectorMediaKey": "fabric-zb-uh-003-c01"
      },
      {
        "id": "NDR-V2-ZB-UH-003-C02",
        "familyId": "NDR-V2-ZB-UH-003",
        "label": "Linen",
        "fabricType": "classification-pending",
        "selectorMediaKey": "fabric-zb-uh-003-c02"
      },
      {
        "id": "NDR-V2-ZB-UH-003-C03",
        "familyId": "NDR-V2-ZB-UH-003",
        "label": "Oatmeal",
        "fabricType": "classification-pending",
        "selectorMediaKey": "fabric-zb-uh-003-c03"
      },
      {
        "id": "NDR-V2-ZB-UH-003-C04",
        "familyId": "NDR-V2-ZB-UH-003",
        "label": "Driftwood",
        "fabricType": "classification-pending",
        "selectorMediaKey": "fabric-zb-uh-003-c04"
      },
      {
        "id": "NDR-V2-ZB-UH-003-C05",
        "familyId": "NDR-V2-ZB-UH-003",
        "label": "Bronze",
        "fabricType": "classification-pending",
        "selectorMediaKey": "fabric-zb-uh-003-c05"
      },
      {
        "id": "NDR-V2-ZB-UH-003-C06",
        "familyId": "NDR-V2-ZB-UH-003",
        "label": "Espresso",
        "fabricType": "classification-pending",
        "selectorMediaKey": "fabric-zb-uh-003-c06"
      },
      {
        "id": "NDR-V2-ZB-SB-016-C01",
        "familyId": "NDR-V2-ZB-SB-016",
        "label": "Cloud White",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-016-c01",
        "weaveDetailMediaKey": "weave-zb-sb-016-c01"
      },
      {
        "id": "NDR-V2-ZB-SB-016-C02",
        "familyId": "NDR-V2-ZB-SB-016",
        "label": "Soft White",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-016-c02",
        "weaveDetailMediaKey": "weave-zb-sb-016-c02"
      },
      {
        "id": "NDR-V2-ZB-SB-016-C03",
        "familyId": "NDR-V2-ZB-SB-016",
        "label": "Linen",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-016-c03",
        "weaveDetailMediaKey": "weave-zb-sb-016-c03"
      },
      {
        "id": "NDR-V2-ZB-SB-016-C04",
        "familyId": "NDR-V2-ZB-SB-016",
        "label": "Violet",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-016-c04",
        "weaveDetailMediaKey": "weave-zb-sb-016-c04"
      },
      {
        "id": "NDR-V2-ZB-SB-016-C05",
        "familyId": "NDR-V2-ZB-SB-016",
        "label": "Blush",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-016-c05",
        "weaveDetailMediaKey": "weave-zb-sb-016-c05"
      },
      {
        "id": "NDR-V2-ZB-SB-016-C06",
        "familyId": "NDR-V2-ZB-SB-016",
        "label": "Sky",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-016-c06",
        "weaveDetailMediaKey": "weave-zb-sb-016-c06"
      },
      {
        "id": "NDR-V2-ZB-SB-017-C01",
        "familyId": "NDR-V2-ZB-SB-017",
        "label": "Silver",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-017-c01",
        "weaveDetailMediaKey": "weave-zb-sb-017-c01"
      },
      {
        "id": "NDR-V2-ZB-SB-017-C02",
        "familyId": "NDR-V2-ZB-SB-017",
        "label": "Mist",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-017-c02",
        "weaveDetailMediaKey": "weave-zb-sb-017-c02"
      },
      {
        "id": "NDR-V2-ZB-SB-017-C03",
        "familyId": "NDR-V2-ZB-SB-017",
        "label": "Oatmeal",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-017-c03",
        "weaveDetailMediaKey": "weave-zb-sb-017-c03"
      },
      {
        "id": "NDR-V2-ZB-SB-017-C04",
        "familyId": "NDR-V2-ZB-SB-017",
        "label": "Linen",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-017-c04",
        "weaveDetailMediaKey": "weave-zb-sb-017-c04"
      },
      {
        "id": "NDR-V2-ZB-SB-017-C05",
        "familyId": "NDR-V2-ZB-SB-017",
        "label": "Bronze",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-017-c05",
        "weaveDetailMediaKey": "weave-zb-sb-017-c05"
      },
      {
        "id": "NDR-V2-ZB-SB-017-C06",
        "familyId": "NDR-V2-ZB-SB-017",
        "label": "Onyx",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-017-c06",
        "weaveDetailMediaKey": "weave-zb-sb-017-c06"
      },
      {
        "id": "NDR-V2-ZB-SB-018-C01",
        "familyId": "NDR-V2-ZB-SB-018",
        "label": "Linen",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-018-c01",
        "weaveDetailMediaKey": "weave-zb-sb-018-c01"
      },
      {
        "id": "NDR-V2-ZB-SB-018-C02",
        "familyId": "NDR-V2-ZB-SB-018",
        "label": "Violet",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-018-c02",
        "weaveDetailMediaKey": "weave-zb-sb-018-c02"
      },
      {
        "id": "NDR-V2-ZB-SB-018-C03",
        "familyId": "NDR-V2-ZB-SB-018",
        "label": "Blush",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-018-c03",
        "weaveDetailMediaKey": "weave-zb-sb-018-c03"
      },
      {
        "id": "NDR-V2-ZB-SB-018-C04",
        "familyId": "NDR-V2-ZB-SB-018",
        "label": "Gold",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-018-c04",
        "weaveDetailMediaKey": "weave-zb-sb-018-c04"
      },
      {
        "id": "NDR-V2-ZB-SB-018-C05",
        "familyId": "NDR-V2-ZB-SB-018",
        "label": "Honey",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-018-c05",
        "weaveDetailMediaKey": "weave-zb-sb-018-c05"
      },
      {
        "id": "NDR-V2-ZB-SB-018-C06",
        "familyId": "NDR-V2-ZB-SB-018",
        "label": "Sage",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-018-c06",
        "weaveDetailMediaKey": "weave-zb-sb-018-c06"
      },
      {
        "id": "NDR-V2-ZB-SB-019-C01",
        "familyId": "NDR-V2-ZB-SB-019",
        "label": "Sky",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-019-c01",
        "weaveDetailMediaKey": "weave-zb-sb-019-c01"
      },
      {
        "id": "NDR-V2-ZB-SB-019-C02",
        "familyId": "NDR-V2-ZB-SB-019",
        "label": "Linen",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-019-c02",
        "weaveDetailMediaKey": "weave-zb-sb-019-c02"
      },
      {
        "id": "NDR-V2-ZB-SB-019-C03",
        "familyId": "NDR-V2-ZB-SB-019",
        "label": "Taupe",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-019-c03",
        "weaveDetailMediaKey": "weave-zb-sb-019-c03"
      },
      {
        "id": "NDR-V2-ZB-SB-019-C04",
        "familyId": "NDR-V2-ZB-SB-019",
        "label": "Espresso",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-019-c04",
        "weaveDetailMediaKey": "weave-zb-sb-019-c04"
      },
      {
        "id": "NDR-V2-ZB-SB-019-C05",
        "familyId": "NDR-V2-ZB-SB-019",
        "label": "Graphite",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-019-c05",
        "weaveDetailMediaKey": "weave-zb-sb-019-c05"
      },
      {
        "id": "NDR-V2-ZB-SB-019-C06",
        "familyId": "NDR-V2-ZB-SB-019",
        "label": "Silver",
        "fabricType": "semi-blackout",
        "selectorMediaKey": "fabric-zb-sb-019-c06",
        "weaveDetailMediaKey": "weave-zb-sb-019-c06"
      }
    ]
  },
  "shangriLa": {
    "families": [],
    "variants": [],
    "reviewStatus": "swatches-pending"
  },
  "cellular": {
    "families": [],
    "variants": []
  },
  "topPicks": {
    "label": "Top Pick",
    "families": [
      "NDR-V2-RL-SO-102",
      "NDR-V2-RL-BO-009",
      "NDR-V2-RL-LF-001",
      "NDR-V2-RL-SO-101",
      "NDR-V2-RL-BO-007",
      "NDR-V2-RL-LF-004",
      "NDR-V2-RL-BO-010",
      "NDR-V2-RL-SO-104",
      "NDR-V2-RL-LF-002"
    ],
    "colors": [
      "NDR-V2-RL-SO-102-C01",
      "NDR-V2-RL-SO-102-C02",
      "NDR-V2-RL-SO-102-C03",
      "NDR-V2-RL-SO-102-C04",
      "NDR-V2-RL-SO-102-C05",
      "NDR-V2-RL-SO-102-C06",
      "NDR-V2-RL-SO-102-C07",
      "NDR-V2-RL-SO-102-C08",
      "NDR-V2-RL-SO-102-C09",
      "NDR-V2-RL-BO-009-C01",
      "NDR-V2-RL-BO-009-C02",
      "NDR-V2-RL-BO-009-C03",
      "NDR-V2-RL-BO-009-C04",
      "NDR-V2-RL-BO-009-C05",
      "NDR-V2-RL-BO-009-C06",
      "NDR-V2-RL-BO-009-C07",
      "NDR-V2-RL-LF-001-C01",
      "NDR-V2-RL-LF-001-C02",
      "NDR-V2-RL-LF-001-C03",
      "NDR-V2-RL-LF-001-C04",
      "NDR-V2-RL-LF-001-C05",
      "NDR-V2-RL-SO-101-C01",
      "NDR-V2-RL-SO-101-C02",
      "NDR-V2-RL-SO-101-C03",
      "NDR-V2-RL-SO-101-C04",
      "NDR-V2-RL-SO-101-C05",
      "NDR-V2-RL-SO-101-C06",
      "NDR-V2-RL-SO-101-C07",
      "NDR-V2-RL-SO-101-C08",
      "NDR-V2-RL-SO-101-C09",
      "NDR-V2-RL-BO-007-C01",
      "NDR-V2-RL-BO-007-C02",
      "NDR-V2-RL-BO-007-C03",
      "NDR-V2-RL-BO-007-C04",
      "NDR-V2-RL-BO-007-C05",
      "NDR-V2-RL-BO-007-C06",
      "NDR-V2-RL-BO-007-C07",
      "NDR-V2-RL-LF-004-C01",
      "NDR-V2-RL-LF-004-C02",
      "NDR-V2-RL-LF-004-C03",
      "NDR-V2-RL-LF-004-C04",
      "NDR-V2-RL-LF-004-C05",
      "NDR-V2-RL-LF-004-C06",
      "NDR-V2-RL-LF-004-C07",
      "NDR-V2-RL-BO-010-C01",
      "NDR-V2-RL-BO-010-C02",
      "NDR-V2-RL-BO-010-C03",
      "NDR-V2-RL-BO-010-C04",
      "NDR-V2-RL-BO-010-C05",
      "NDR-V2-RL-BO-010-C06",
      "NDR-V2-RL-BO-010-C07",
      "NDR-V2-RL-SO-104-C01",
      "NDR-V2-RL-SO-104-C02",
      "NDR-V2-RL-SO-104-C03",
      "NDR-V2-RL-SO-104-C04",
      "NDR-V2-RL-SO-104-C05",
      "NDR-V2-RL-SO-104-C06",
      "NDR-V2-RL-SO-104-C07",
      "NDR-V2-RL-SO-104-C08",
      "NDR-V2-RL-LF-002-C01",
      "NDR-V2-RL-LF-002-C02",
      "NDR-V2-RL-LF-002-C03",
      "NDR-V2-RL-LF-002-C04",
      "NDR-V2-RL-LF-002-C05"
    ]
  }
};
  Object.defineProperties(catalog, {
    catalogRevision: { value: "NDR_V2" },
    storageNamespace: { value: "ndr-preview-order-v2" },
  });
  return Object.freeze(catalog);
});
